import { jsx as c, jsxs as N, Fragment as q } from "react/jsx-runtime";
import T, { createElement as E, useState as H, useRef as I, useCallback as P, useLayoutEffect as Te, useEffect as W, forwardRef as tt, createContext as V, useReducer as Re, useContext as K, useId as he, useMemo as ot } from "react";
import { createPortal as Ne } from "react-dom";
const st = {
  Primary: "alert-primary",
  Secondary: "alert-secondary",
  Success: "alert-success",
  Danger: "alert-danger",
  Warning: "alert-warning",
  Info: "alert-info",
  Light: "alert-light",
  Dark: "alert-dark"
}, nt = new Set(Object.values(st)), cn = ({
  children: e,
  className: o,
  color: t,
  ...s
}) => {
  const n = [
    ...t ? [t] : []
  ], l = [{ prop: t, set: nt }], d = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (f) => !l.some(({ prop: a, set: m }) => a && m.has(f))
  ), i = [
    "alert",
    ...new Set([...n, ...d].filter((f) => f !== "alert"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: i, ...s, children: e });
}, lt = {
  Primary: "text-bg-primary",
  Secondary: "text-bg-secondary",
  Success: "text-bg-success",
  Danger: "text-bg-danger",
  Warning: "text-bg-warning",
  Info: "text-bg-info",
  Light: "text-bg-light",
  Dark: "text-bg-dark"
}, rt = {
  None: "rounded-0",
  Pill: "rounded-pill",
  Circle: "rounded-circle"
}, at = {
  Absolute: "position-absolute",
  Relative: "position-relative",
  Static: "position-static"
}, it = {
  TopStart: "translate-middle top-0 start-0",
  TopCenter: "translate-middle top-0 start-50",
  TopEnd: "translate-middle top-0 start-100",
  MiddleStart: "translate-middle top-50 start-0",
  MiddleCenter: "translate-middle top-50 start-50",
  MiddleEnd: "translate-middle top-50 start-100",
  BottomStart: "translate-middle top-100 start-0",
  BottomCenter: "translate-middle top-100 start-50",
  BottomEnd: "translate-middle top-100 start-100"
}, ct = new Set(Object.values(lt)), dt = new Set(Object.values(at)), ft = new Set(Object.values(rt)), je = /* @__PURE__ */ new Set();
for (const e of Object.values(it))
  for (const o of e.split(/\s+/).filter(Boolean))
    je.add(o);
const dn = ({
  children: e,
  className: o,
  color: t,
  position: s,
  rounded: n,
  placement: l,
  ...r
}) => {
  const d = [
    ...t ? [t] : [],
    ...s ? [s] : [],
    ...n ? [n] : [],
    ...l ? l.split(/\s+/).filter(Boolean) : []
  ], i = [
    { prop: t, set: ct },
    { prop: s, set: dt },
    { prop: n, set: ft },
    { prop: l, set: je }
  ], a = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (u) => !i.some(({ prop: g, set: w }) => g && w.has(u))
  ), m = [
    "badge",
    ...new Set([...d, ...a].filter((u) => u !== "badge"))
  ].join(" ");
  return /* @__PURE__ */ c("span", { className: m, ...r, children: e });
}, ut = {
  Button: "button",
  Submit: "submit",
  Reset: "reset"
}, me = {
  Primary: "btn-primary",
  OutlinePrimary: "btn-outline-primary",
  Secondary: "btn-secondary",
  OutlineSecondary: "btn-outline-secondary",
  Success: "btn-success",
  OutlineSuccess: "btn-outline-success",
  Danger: "btn-danger",
  OutlineDanger: "btn-outline-danger",
  Warning: "btn-warning",
  OutlineWarning: "btn-outline-warning",
  Info: "btn-info",
  OutlineInfo: "btn-outline-info",
  Light: "btn-light",
  OutlineLight: "btn-outline-light",
  Dark: "btn-dark",
  OutlineDark: "btn-outline-dark",
  Link: "btn-link"
}, Pe = {
  Sm: "btn-sm",
  Lg: "btn-lg"
}, ee = {
  Sm: "btn-group-sm",
  Lg: "btn-group-lg"
}, mt = new Set(Object.values(me)), pt = new Set(Object.values(Pe)), gt = /* @__PURE__ */ new Set(["active"]), de = ({
  el: e,
  children: o,
  className: t,
  color: s,
  size: n,
  type: l = "button",
  disabled: r = !1,
  active: d = !1,
  ...i
}) => {
  const f = e || "button", a = [
    ...s ? [s] : [],
    ...n ? [n] : [],
    ...d ? ["active"] : []
  ], m = [
    { prop: s, set: mt },
    { prop: n, set: pt },
    { prop: d, set: gt }
  ], g = ((t == null ? void 0 : t.split(/\s+/).filter(Boolean)) ?? []).filter(
    (X) => !m.some(({ prop: k, set: p }) => k && p.has(X))
  ), w = [
    "btn",
    ...new Set([...a, ...g].filter((X) => X !== "btn"))
  ].join(" "), b = f === "button" ? { ...i, className: w, type: l, disabled: r } : { ...i, className: w };
  return E(f, b, o);
}, xt = new Set(Object.values(ee)), wt = /* @__PURE__ */ new Set(["btn-group", "btn-group-vertical"]), re = ({
  children: e,
  className: o,
  size: t,
  vertical: s = !1,
  ...n
}) => {
  const l = [...t ? [t] : []], r = [
    { prop: t, set: xt },
    { prop: !0, set: wt }
  ], i = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (m) => !r.some(({ prop: u, set: g }) => u && g.has(m))
  ), a = [
    s ? "btn-group-vertical" : "btn-group",
    ...new Set(
      [...l, ...i].filter(
        (m) => m !== "btn-group" && m !== "btn-group-vertical"
      )
    )
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: a, role: "group", ...n, children: e });
}, Me = {
  Border: "spinner-border",
  Grow: "spinner-grow"
}, St = {
  SpinnerBorderSm: "spinner-border-sm",
  SpinnerGrowSm: "spinner-grow-sm"
}, bt = {
  Primary: "text-primary",
  Secondary: "text-secondary",
  Success: "text-success",
  Danger: "text-danger",
  Warning: "text-warning",
  Info: "text-info",
  Light: "text-light",
  Dark: "text-dark"
}, ht = new Set(Object.values(Me)), Ct = new Set(Object.values(St)), vt = new Set(Object.values(bt)), fn = ({
  id: e,
  spinnerType: o = Me.Border,
  color: t,
  size: s,
  style: n,
  className: l
}) => {
  const r = [
    o,
    ...t ? [t] : [],
    ...s ? [s] : []
  ], d = [
    { prop: !0, set: ht },
    { prop: !!t, set: vt },
    { prop: !!s, set: Ct }
  ], f = ((l == null ? void 0 : l.split(/\s+/).filter(Boolean)) ?? []).filter(
    (m) => !d.some(({ prop: u, set: g }) => u && g.has(m))
  ), a = [.../* @__PURE__ */ new Set([...r, ...f])].join(" ").trim() || void 0;
  return /* @__PURE__ */ c("div", { id: e, className: a, style: n, role: "status", children: /* @__PURE__ */ c("span", { className: "visually-hidden", children: "Loading..." }) });
}, yt = {
  Primary: "bg-primary",
  Secondary: "bg-secondary",
  Success: "bg-success",
  Danger: "bg-danger",
  Warning: "bg-warning",
  Info: "bg-info",
  Light: "bg-light",
  Dark: "bg-dark"
}, Ot = {
  W0: "w-0",
  W25: "w-25",
  W50: "w-50",
  W75: "w-75",
  W100: "w-100"
}, De = {
  Visible: "overflow-visible",
  Hidden: "overflow-hidden"
}, Lt = /* @__PURE__ */ new Set(["progress"]), Bt = /* @__PURE__ */ new Set(["progress-bar"]), Xt = /* @__PURE__ */ new Set(["progress-bar-striped"]), Et = /* @__PURE__ */ new Set(["progress-bar-animated"]), kt = new Set(Object.values(yt)), Tt = new Set(Object.values(Ot)), Rt = new Set(Object.values(De)), un = ({
  id: e,
  className: o,
  barClassName: t,
  style: s,
  isStriped: n = !1,
  isAnimating: l = !1,
  progressValue: r,
  labelOverflow: d = De.Hidden,
  progressValueClass: i,
  color: f,
  height: a,
  label: m
}) => {
  const u = ["progress"], g = [{ prop: !0, set: Lt }], b = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (x) => !g.some(({ prop: S, set: C }) => S && C.has(x))
  ), X = [.../* @__PURE__ */ new Set([...u, ...b])].join(" ").trim(), k = [
    "progress-bar",
    ...f ? [f] : [],
    ...i ? [i] : [],
    ...d ? [d] : [],
    ...n ? ["progress-bar-striped"] : [],
    ...l ? ["progress-bar-animated"] : []
  ], p = [
    { prop: !0, set: Bt },
    { prop: !!f, set: kt },
    { prop: !!i, set: Tt },
    { prop: !0, set: Rt },
    { prop: n, set: Xt },
    { prop: l, set: Et }
  ], O = ((t == null ? void 0 : t.split(/\s+/).filter(Boolean)) ?? []).filter(
    (x) => !p.some(({ prop: S, set: C }) => S && C.has(x))
  ), j = [.../* @__PURE__ */ new Set([...k, ...O])].join(" ").trim(), v = {
    ...s,
    ...a != null && a !== "" ? { height: typeof a == "number" ? `${a}px` : a } : {}
  }, h = r != null ? `${Math.min(Math.max(r, 0), 100)}%` : void 0;
  return /* @__PURE__ */ c(
    "div",
    {
      id: e,
      style: v,
      className: X,
      role: "progressbar",
      children: /* @__PURE__ */ c("div", { className: j, style: h != null ? { width: h } : void 0, children: m })
    }
  );
}, G = {
  Top: "top",
  Bottom: "bottom",
  Start: "start",
  End: "end"
}, mn = ({
  children: e,
  text: o,
  className: t,
  placement: s = G.Top,
  isHtml: n = !1,
  container: l = "body",
  id: r,
  style: d
}) => {
  const [i, f] = H(!1), [a, m] = H({ top: 0, left: 0 }), u = I(null), g = I(null), w = P(() => {
    if (!u.current || !g.current) return;
    const h = u.current.getBoundingClientRect(), x = g.current.getBoundingClientRect();
    let S = 0, C = 0;
    if (l === "body") {
      const L = window.scrollX || window.pageXOffset, B = window.scrollY || window.pageYOffset;
      switch (s) {
        case G.Top:
          S = h.top + B - x.height - 8, C = h.left + L + (h.width - x.width) / 2;
          break;
        case G.Bottom:
          S = h.bottom + B + 8, C = h.left + L + (h.width - x.width) / 2;
          break;
        case G.Start:
          S = h.top + B + (h.height - x.height) / 2, C = h.left + L - x.width - 8;
          break;
        case G.End:
          S = h.top + B + (h.height - x.height) / 2, C = h.right + L + 8;
          break;
      }
    } else {
      const B = ((_) => _.offsetParent || document.documentElement)(u.current), R = B.getBoundingClientRect();
      let D = h.top - R.top, M = h.left - R.left;
      switch (B !== document.documentElement && B !== document.body && (D += B.scrollTop, M += B.scrollLeft), s) {
        case G.Top:
          S = D - x.height - 8, C = M + (h.width - x.width) / 2;
          break;
        case G.Bottom:
          S = D + h.height + 8, C = M + (h.width - x.width) / 2;
          break;
        case G.Start:
          S = D + (h.height - x.height) / 2, C = M - x.width - 8;
          break;
        case G.End:
          S = D + (h.height - x.height) / 2, C = M + h.width + 8;
          break;
      }
    }
    m({ top: S, left: C });
  }, [l, s]);
  Te(() => {
    i && w();
  }, [i, l, s, w]), W(() => {
    if (!i) return;
    const h = () => {
      f(!1);
    }, x = () => {
      w();
    }, S = (C) => {
      C.key === "Escape" && f(!1);
    };
    return window.addEventListener("scroll", h, !0), window.addEventListener("resize", x), document.addEventListener("keydown", S), () => {
      window.removeEventListener("scroll", h, !0), window.removeEventListener("resize", x), document.removeEventListener("keydown", S);
    };
  }, [i, w]);
  const b = () => {
    f(!0);
  }, X = () => {
    f(!1);
  }, k = () => {
    f(!0);
  }, p = (h) => {
    var S;
    const x = h.relatedTarget;
    x && (h.currentTarget.contains(x) || (S = g.current) != null && S.contains(x)) || requestAnimationFrame(() => {
      var L, B;
      const C = document.activeElement;
      C && ((L = u.current) != null && L.contains(C)) || C && ((B = g.current) != null && B.contains(C)) || f(!1);
    });
  }, y = [
    "tooltip",
    `bs-tooltip-${s}`,
    i ? "show" : "",
    t
  ].filter(Boolean).join(" "), O = {
    position: "absolute",
    top: `${a.top}px`,
    left: `${a.left}px`,
    zIndex: 1080,
    opacity: 1,
    // Avoid shrink-to-fit to the tiny "remaining width" inside a narrow positioned
    // ancestor (inline mode + end/start), which forced one word per line.
    width: "max-content"
  }, v = /* @__PURE__ */ N("div", { ref: g, className: y, role: "tooltip", style: O, children: [
    /* @__PURE__ */ c("div", { className: "tooltip-arrow" }),
    /* @__PURE__ */ c("div", { className: "tooltip-inner", children: n ? /* @__PURE__ */ c("span", { dangerouslySetInnerHTML: { __html: o } }) : o })
  ] });
  return /* @__PURE__ */ N(q, { children: [
    /* @__PURE__ */ c(
      "span",
      {
        className: "d-inline-block",
        ref: u,
        id: r,
        style: d,
        onMouseEnter: b,
        onMouseLeave: X,
        onFocus: k,
        onBlur: p,
        children: e
      }
    ),
    i && (l === "body" ? Ne(v, document.body) : v)
  ] });
}, A = {
  Top: "top",
  Bottom: "bottom",
  Start: "start",
  End: "end"
}, pn = ({
  children: e,
  title: o,
  content: t,
  className: s,
  placement: n = A.Top,
  trigger: l = "click",
  container: r = "body",
  id: d,
  style: i
}) => {
  const [f, a] = H(!1), [m, u] = H({ top: 0, left: 0 }), g = I(null), w = I(null), b = P(() => {
    if (!g.current || !w.current) return;
    const x = g.current.getBoundingClientRect(), S = w.current.getBoundingClientRect();
    let C = 0, L = 0;
    if (r === "body") {
      const B = window.scrollX || window.pageXOffset, R = window.scrollY || window.pageYOffset;
      switch (n) {
        case A.Top:
          C = x.top + R - S.height - 8, L = x.left + B + (x.width - S.width) / 2;
          break;
        case A.Bottom:
          C = x.bottom + R + 8, L = x.left + B + (x.width - S.width) / 2;
          break;
        case A.Start:
          C = x.top + R + (x.height - S.height) / 2, L = x.left + B - S.width - 8;
          break;
        case A.End:
          C = x.top + R + (x.height - S.height) / 2, L = x.right + B + 8;
          break;
      }
    } else {
      const R = ((be) => be.offsetParent || document.documentElement)(g.current), D = R.getBoundingClientRect();
      let M = x.top - D.top, _ = x.left - D.left;
      switch (R !== document.documentElement && R !== document.body && (M += R.scrollTop, _ += R.scrollLeft), n) {
        case A.Top:
          C = M - S.height - 8, L = _ + (x.width - S.width) / 2;
          break;
        case A.Bottom:
          C = M + x.height + 8, L = _ + (x.width - S.width) / 2;
          break;
        case A.Start:
          C = M + (x.height - S.height) / 2, L = _ - S.width - 8;
          break;
        case A.End:
          C = M + (x.height - S.height) / 2, L = _ + x.width + 8;
          break;
      }
    }
    u({ top: C, left: L });
  }, [r, n]);
  Te(() => {
    f && b();
  }, [f, r, n, b]), W(() => {
    if (!f) return;
    const x = () => {
      l === "hover" && a(!1);
    }, S = () => {
      b();
    }, C = (B) => {
      l !== "hover" && w.current && g.current && !w.current.contains(B.target) && !g.current.contains(B.target) && a(!1);
    }, L = (B) => {
      B.key === "Escape" && a(!1);
    };
    return window.addEventListener("scroll", x, !0), window.addEventListener("resize", S), document.addEventListener("mousedown", C), document.addEventListener("keydown", L), () => {
      window.removeEventListener("scroll", x, !0), window.removeEventListener("resize", S), document.removeEventListener("mousedown", C), document.removeEventListener("keydown", L);
    };
  }, [f, l, b]);
  const X = () => {
    l === "click" && a(!f);
  }, k = () => {
    l === "hover" && a(!0);
  }, p = () => {
    l === "hover" && a(!1);
  }, y = () => {
    l === "focus" && a(!0);
  }, O = (x) => {
    var C;
    if (l !== "focus") return;
    const S = x.relatedTarget;
    S && (x.currentTarget.contains(S) || (C = w.current) != null && C.contains(S)) || requestAnimationFrame(() => {
      var B, R;
      const L = document.activeElement;
      L && ((B = g.current) != null && B.contains(L)) || L && ((R = w.current) != null && R.contains(L)) || a(!1);
    });
  }, j = [
    "popover",
    `bs-popover-${n}`,
    f ? "show" : "",
    s
  ].filter(Boolean).join(" "), v = {
    position: "absolute",
    top: `${m.top}px`,
    left: `${m.left}px`,
    zIndex: 1080,
    opacity: 1,
    // Inline end/start placement sits near the edge of a narrow positioned ancestor;
    // without this, shrink-to-fit leaves almost no width and body text stacks one word per line.
    width: "max-content"
  }, h = /* @__PURE__ */ N(
    "div",
    {
      ref: w,
      className: j,
      role: "popover",
      style: v,
      children: [
        /* @__PURE__ */ c("div", { className: "popover-arrow" }),
        o ? /* @__PURE__ */ c("div", { className: "popover-header", children: o }) : null,
        /* @__PURE__ */ c("div", { className: "popover-body", children: t })
      ]
    }
  );
  return /* @__PURE__ */ N(q, { children: [
    /* @__PURE__ */ c(
      "span",
      {
        className: "d-inline-block",
        ref: g,
        id: d,
        style: i,
        onClick: X,
        onMouseEnter: k,
        onMouseLeave: p,
        onFocus: y,
        onBlur: O,
        tabIndex: l === "focus" ? 0 : void 0,
        children: e
      }
    ),
    f && (r === "body" ? Ne(h, document.body) : h)
  ] });
}, Nt = {}, ae = new URL("" + new URL("assets/icons/icons.svg", import.meta.url).href, import.meta.url).href;
function jt() {
  var t;
  const e = Nt, o = (t = e == null ? void 0 : e.VITE_REBOOTUI_ICONS_SPRITE) == null ? void 0 : t.trim();
  return o ? o.replace(/\/$/, "") : typeof document < "u" && typeof ae == "string" && ae.includes("/.vite/deps/") ? new URL(
    "node_modules/@reactufy/rebootui/dist/assets/icons/icons.svg",
    document.baseURI
  ).href : ae;
}
const gn = ({ name: e, className: o, width: t, height: s, fill: n }) => {
  const l = `${jt()}#${e}`;
  return /* @__PURE__ */ c(
    "svg",
    {
      className: o,
      width: t,
      height: s || t,
      fill: n ?? "currentColor",
      "aria-hidden": "true",
      children: /* @__PURE__ */ c("use", { href: l })
    }
  );
}, Pt = /* @__PURE__ */ new Set(["img-fluid"]), Mt = /* @__PURE__ */ new Set(["img-thumbnail"]), xn = ({
  className: e,
  fluid: o = !1,
  thumbnail: t = !1,
  ...s
}) => {
  const n = [
    ...o ? ["img-fluid"] : [],
    ...t ? ["img-thumbnail"] : []
  ], l = [
    { prop: o, set: Pt },
    { prop: t, set: Mt }
  ], d = ((e == null ? void 0 : e.split(/\s+/).filter(Boolean)) ?? []).filter(
    (f) => !l.some(({ prop: a, set: m }) => a && m.has(f))
  ), i = [.../* @__PURE__ */ new Set([...n, ...d])].join(" ").trim() || void 0;
  return /* @__PURE__ */ c("img", { className: i, ...s });
}, Dt = ({ className: e, children: o, ...t }) => {
  const s = [
    "figure-caption",
    ...new Set(
      (e ?? "").split(/\s+/).filter(Boolean).filter((n) => n !== "figure-caption")
    )
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ c("figcaption", { className: s, ...t, children: o });
}, It = (({ className: e, children: o, ...t }) => {
  const s = [
    "figure",
    ...new Set(
      (e ?? "").split(/\s+/).filter(Boolean).filter((n) => n !== "figure")
    )
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ c("figure", { className: s, ...t, children: o });
});
It.figureCaption = Dt;
const Gt = {
  Display1: "display-1",
  Display2: "display-2",
  Display3: "display-3",
  Display4: "display-4",
  Display5: "display-5",
  Display6: "display-6",
  Fs1: "fs-1",
  Fs2: "fs-2",
  Fs3: "fs-3",
  Fs4: "fs-4",
  Fs5: "fs-5",
  Fs6: "fs-6"
}, At = {
  Primary: "text-primary",
  Secondary: "text-secondary",
  Success: "text-success",
  Danger: "text-danger",
  Warning: "text-warning",
  Info: "text-info",
  Light: "text-light",
  Dark: "text-dark",
  Muted: "text-muted",
  Body: "text-body",
  BodySecondary: "text-body-secondary",
  BodyTertiary: "text-body-tertiary",
  BodyEmphasis: "text-body-emphasis",
  White: "text-white",
  Black: "text-black"
}, Ft = new Set(Object.values(Gt)), Wt = new Set(Object.values(At)), wn = ({
  el: e,
  children: o,
  size: t,
  color: s,
  className: n,
  ...l
}) => {
  const r = e || "h2", d = [
    ...t ? [t] : [],
    ...s ? [s] : []
  ], i = [
    { prop: t, set: Ft },
    { prop: s, set: Wt }
  ], a = ((n == null ? void 0 : n.split(/\s+/).filter(Boolean)) ?? []).filter(
    (u) => !i.some(({ prop: g, set: w }) => g && w.has(u))
  ), m = [.../* @__PURE__ */ new Set([...d, ...a])].join(" ").trim() || void 0;
  return E(r, { ...l, className: m }, o);
}, Sn = ({
  el: e,
  children: o,
  ...t
}) => E(e ?? "p", t, o), bn = ({
  el: e,
  children: o,
  ...t
}) => /* @__PURE__ */ c(e || "div", { ...t, children: o }), hn = ({
  el: e,
  children: o,
  ...t
}) => E(e || "ul", t, o), Cn = ({
  el: e,
  children: o,
  ...t
}) => E(e || "li", t, o), pe = {
  Small: "table-sm",
  Default: ""
}, ge = {
  Default: "",
  Dark: "table-dark",
  Primary: "table-primary",
  Secondary: "table-secondary",
  Success: "table-success",
  Danger: "table-danger",
  Warning: "table-warning",
  Info: "table-info",
  Light: "table-light"
}, Ht = pe, _t = ge, $t = /* @__PURE__ */ new Set(["table-striped"]), zt = /* @__PURE__ */ new Set(["table-striped-columns"]), Yt = /* @__PURE__ */ new Set(["table-bordered"]), Ut = /* @__PURE__ */ new Set(["table-borderless"]), qt = /* @__PURE__ */ new Set(["table-hover"]), Vt = new Set(
  Object.values(pe).filter((e) => e.length > 0)
), Kt = new Set(
  Object.values(ge).filter((e) => e.length > 0)
), Jt = /* @__PURE__ */ new Set(["table-dark"]);
function Ie({
  striped: e,
  stripedColumns: o,
  bordered: t,
  borderless: s,
  hover: n,
  size: l = pe.Default,
  color: r = ge.Default,
  className: d
}) {
  const i = [
    ...e ? ["table-striped"] : [],
    ...o ? ["table-striped-columns"] : [],
    ...t ? ["table-bordered"] : [],
    ...s ? ["table-borderless"] : [],
    ...n ? ["table-hover"] : [],
    ...l ? [l] : [],
    ...r ? [r] : []
  ], f = [
    { prop: e, set: $t },
    { prop: o, set: zt },
    { prop: t, set: Yt },
    { prop: s, set: Ut },
    { prop: n, set: qt },
    { prop: l, set: Vt },
    { prop: r, set: Kt }
  ], m = ((d == null ? void 0 : d.split(/\s+/).filter(Boolean)) ?? []).filter(
    (u) => u !== "table" && !f.some(({ prop: g, set: w }) => g && w.has(u))
  );
  return [
    "table",
    ...new Set([...i, ...m].filter((u) => u !== "table"))
  ].join(" ");
}
function Ge(e, o) {
  const t = [...e ? ["table-dark"] : []], s = [{ prop: e, set: Jt }], l = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (d) => !s.some(({ prop: i, set: f }) => i && f.has(d))
  );
  return [.../* @__PURE__ */ new Set([...t, ...l])].join(" ") || void 0;
}
const vn = ({
  columns: e,
  data: o,
  striped: t = !1,
  stripedColumns: s = !1,
  bordered: n = !1,
  borderless: l = !1,
  hover: r = !1,
  darkHeader: d = !1,
  size: i = Ht.Default,
  color: f = _t.Default,
  responsive: a = !0,
  className: m,
  caption: u,
  captionTop: g = !1,
  onRowClick: w,
  rowClassName: b,
  emptyMessage: X = "No data available",
  ...k
}) => {
  const p = Ie({
    striped: t,
    stripedColumns: s,
    bordered: n,
    borderless: l,
    hover: r,
    size: i,
    color: f,
    className: m
  }), y = (x) => {
    switch (x) {
      case "center":
        return "text-center";
      case "right":
        return "text-end";
      case "left":
        return "text-start";
      default:
        return "";
    }
  }, O = (x, S) => typeof b == "function" ? b(x, S) : b || "", j = (x, S) => {
    w && w(x, S);
  }, v = /* @__PURE__ */ N("table", { className: p, ...k, children: [
    u && /* @__PURE__ */ c("caption", { className: g ? "caption-top" : "", children: u }),
    /* @__PURE__ */ c("thead", { className: Ge(d, void 0), children: /* @__PURE__ */ c("tr", { children: e.map((x, S) => {
      const C = [
        x.headerClassName,
        y(x.align)
      ].filter(Boolean).join(" "), L = {};
      return x.width && (L.width = typeof x.width == "number" ? `${x.width}px` : x.width), /* @__PURE__ */ c(
        "th",
        {
          className: C || void 0,
          style: Object.keys(L).length > 0 ? L : void 0,
          children: x.header
        },
        S
      );
    }) }) }),
    /* @__PURE__ */ c("tbody", { children: o.length === 0 ? /* @__PURE__ */ c("tr", { children: /* @__PURE__ */ c(
      "td",
      {
        colSpan: e.length,
        className: "text-center text-muted py-4",
        children: X
      }
    ) }) : o.map((x, S) => {
      const C = O(x, S), L = !!w;
      return /* @__PURE__ */ c(
        "tr",
        {
          className: `${C} ${L ? "cursor-pointer" : ""}`,
          onClick: () => j(x, S),
          style: L ? { cursor: "pointer" } : void 0,
          children: e.map((B, R) => {
            const D = typeof B.accessor == "function" ? B.accessor(x) : x[B.accessor], M = [
              B.className,
              y(B.align)
            ].filter(Boolean).join(" ");
            return /* @__PURE__ */ c(
              "td",
              {
                className: M || void 0,
                children: D
              },
              R
            );
          })
        },
        S
      );
    }) })
  ] });
  if (a === !1)
    return v;
  const h = a === !0 ? "table-responsive" : `table-responsive-${a}`;
  return /* @__PURE__ */ c("div", { className: h, children: v });
}, Qt = ({ className: e, dark: o, children: t, ...s }) => /* @__PURE__ */ c("thead", { className: Ge(o, e), ...s, children: t }), Zt = ({ children: e, ...o }) => /* @__PURE__ */ c("tbody", { ...o, children: e }), eo = ({ children: e, ...o }) => /* @__PURE__ */ c("tfoot", { ...o, children: e }), to = ({ children: e, ...o }) => /* @__PURE__ */ c("tr", { ...o, children: e }), oo = ({ children: e, ...o }) => /* @__PURE__ */ c("th", { ...o, children: e }), so = ({ children: e, ...o }) => /* @__PURE__ */ c("td", { ...o, children: e }), no = ({ className: e, children: o, ...t }) => /* @__PURE__ */ c("caption", { className: e, ...t, children: o }), lo = ({
  children: e,
  striped: o,
  stripedColumns: t,
  bordered: s,
  borderless: n,
  hover: l,
  size: r,
  color: d,
  responsive: i = !1,
  className: f,
  ...a
}) => {
  const m = Ie({
    striped: o,
    stripedColumns: t,
    bordered: s,
    borderless: n,
    hover: l,
    size: r,
    color: d,
    className: f
  }), u = /* @__PURE__ */ c("table", { className: m, ...a, children: e });
  if (i === !1)
    return u;
  const g = i === !0 ? "table-responsive" : `table-responsive-${i}`;
  return /* @__PURE__ */ c("div", { className: g, children: u });
}, yn = Object.assign(lo, {
  Thead: Qt,
  Tbody: Zt,
  Tfoot: eo,
  Tr: to,
  Th: oo,
  Td: so,
  Caption: no
}), ro = {
  Fluid: "container-fluid",
  Sm: "container-sm",
  Md: "container-md",
  Lg: "container-lg",
  Xl: "container-xl",
  Xxl: "container-xxl"
}, On = ({
  children: e,
  size: o,
  className: t,
  ...s
}) => {
  const n = Object.values(ro), l = [
    { prop: o, set: new Set(n) }
  ], d = ((t == null ? void 0 : t.split(" ").filter(Boolean)) ?? []).filter(
    (a) => !l.some(({ prop: m, set: u }) => m && u.has(a))
  ), i = n.some((a) => t == null ? void 0 : t.split(" ").includes(a)), f = [
    o && n.includes(o) ? o : i ? "" : "container",
    ...new Set([...d].filter((a) => a !== "container"))
  ].join(" ").trim();
  return /* @__PURE__ */ c("div", { className: f, ...s, children: e });
}, Ce = {
  Flex: "d-flex",
  InlineFlex: "d-inline-flex",
  SmFlex: "d-sm-flex",
  MdFlex: "d-md-flex",
  LgFlex: "d-lg-flex",
  XlFlex: "d-xl-flex",
  XxlFlex: "d-xxl-flex",
  SmInlineFlex: "d-sm-inline-flex",
  MdInlineFlex: "d-md-inline-flex",
  LgInlineFlex: "d-lg-inline-flex",
  XlInlineFlex: "d-xl-inline-flex",
  XxlInlineFlex: "d-xxl-inline-flex"
}, ao = {
  Row: "flex-row",
  RowReverse: "flex-row-reverse",
  Column: "flex-column",
  ColumnReverse: "flex-column-reverse",
  SmRow: "flex-sm-row",
  SmRowReverse: "flex-sm-row-reverse",
  SmColumn: "flex-sm-column",
  SmColumnReverse: "flex-sm-column-reverse",
  MdRow: "flex-md-row",
  MdRowReverse: "flex-md-row-reverse",
  MdColumn: "flex-md-column",
  MdColumnReverse: "flex-md-column-reverse",
  LgRow: "flex-lg-row",
  LgRowReverse: "flex-lg-row-reverse",
  LgColumn: "flex-lg-column",
  LgColumnReverse: "flex-lg-column-reverse",
  XlRow: "flex-xl-row",
  XlRowReverse: "flex-xl-row-reverse",
  XlColumn: "flex-xl-column",
  XlColumnReverse: "flex-xl-column-reverse",
  XxlRow: "flex-xxl-row",
  XxlRowReverse: "flex-xxl-row-reverse",
  XxlColumn: "flex-xxl-column",
  XxlColumnReverse: "flex-xxl-column-reverse"
}, io = {
  Wrap: "flex-wrap",
  Nowrap: "flex-nowrap",
  WrapReverse: "flex-wrap-reverse",
  SmWrap: "flex-sm-wrap",
  SmNowrap: "flex-sm-nowrap",
  SmWrapReverse: "flex-sm-wrap-reverse",
  MdWrap: "flex-md-wrap",
  MdNowrap: "flex-md-nowrap",
  MdWrapReverse: "flex-md-wrap-reverse",
  LgWrap: "flex-lg-wrap",
  LgNowrap: "flex-lg-nowrap",
  LgWrapReverse: "flex-lg-wrap-reverse",
  XlWrap: "flex-xl-wrap",
  XlNowrap: "flex-xl-nowrap",
  XlWrapReverse: "flex-xl-wrap-reverse",
  XxlWrap: "flex-xxl-wrap",
  XxlNowrap: "flex-xxl-nowrap",
  XxlWrapReverse: "flex-xxl-wrap-reverse"
}, Ae = {
  Start: "align-items-start",
  End: "align-items-end",
  Center: "align-items-center",
  Baseline: "align-items-baseline",
  Stretch: "align-items-stretch",
  SmStart: "align-items-sm-start",
  SmEnd: "align-items-sm-end",
  SmCenter: "align-items-sm-center",
  SmBaseline: "align-items-sm-baseline",
  SmStretch: "align-items-sm-stretch",
  MdStart: "align-items-md-start",
  MdEnd: "align-items-md-end",
  MdCenter: "align-items-md-center",
  MdBaseline: "align-items-md-baseline",
  MdStretch: "align-items-md-stretch",
  LgStart: "align-items-lg-start",
  LgEnd: "align-items-lg-end",
  LgCenter: "align-items-lg-center",
  LgBaseline: "align-items-lg-baseline",
  LgStretch: "align-items-lg-stretch",
  XlStart: "align-items-xl-start",
  XlEnd: "align-items-xl-end",
  XlCenter: "align-items-xl-center",
  XlBaseline: "align-items-xl-baseline",
  XlStretch: "align-items-xl-stretch",
  XxlStart: "align-items-xxl-start",
  XxlEnd: "align-items-xxl-end",
  XxlCenter: "align-items-xxl-center",
  XxlBaseline: "align-items-xxl-baseline",
  XxlStretch: "align-items-xxl-stretch"
}, Fe = {
  Auto: "align-self-auto",
  Start: "align-self-start",
  End: "align-self-end",
  Center: "align-self-center",
  Baseline: "align-self-baseline",
  Stretch: "align-self-stretch",
  SmAuto: "align-self-sm-auto",
  SmStart: "align-self-sm-start",
  SmEnd: "align-self-sm-end",
  SmCenter: "align-self-sm-center",
  SmBaseline: "align-self-sm-baseline",
  SmStretch: "align-self-sm-stretch",
  MdAuto: "align-self-md-auto",
  MdStart: "align-self-md-start",
  MdEnd: "align-self-md-end",
  MdCenter: "align-self-md-center",
  MdBaseline: "align-self-md-baseline",
  MdStretch: "align-self-md-stretch",
  LgAuto: "align-self-lg-auto",
  LgStart: "align-self-lg-start",
  LgEnd: "align-self-lg-end",
  LgCenter: "align-self-lg-center",
  LgBaseline: "align-self-lg-baseline",
  LgStretch: "align-self-lg-stretch",
  XlAuto: "align-self-xl-auto",
  XlStart: "align-self-xl-start",
  XlEnd: "align-self-xl-end",
  XlCenter: "align-self-xl-center",
  XlBaseline: "align-self-xl-baseline",
  XlStretch: "align-self-xl-stretch",
  XxlAuto: "align-self-xxl-auto",
  XxlStart: "align-self-xxl-start",
  XxlEnd: "align-self-xxl-end",
  XxlCenter: "align-self-xxl-center",
  XxlBaseline: "align-self-xxl-baseline",
  XxlStretch: "align-self-xxl-stretch"
}, We = {
  Start: "justify-content-start",
  End: "justify-content-end",
  Center: "justify-content-center",
  Between: "justify-content-between",
  Around: "justify-content-around",
  Evenly: "justify-content-evenly",
  SmStart: "justify-content-sm-start",
  SmEnd: "justify-content-sm-end",
  SmCenter: "justify-content-sm-center",
  SmBetween: "justify-content-sm-between",
  SmAround: "justify-content-sm-around",
  SmEvenly: "justify-content-sm-evenly",
  MdStart: "justify-content-md-start",
  MdEnd: "justify-content-md-end",
  MdCenter: "justify-content-md-center",
  MdBetween: "justify-content-md-between",
  MdAround: "justify-content-md-around",
  MdEvenly: "justify-content-md-evenly",
  LgStart: "justify-content-lg-start",
  LgEnd: "justify-content-lg-end",
  LgCenter: "justify-content-lg-center",
  LgBetween: "justify-content-lg-between",
  LgAround: "justify-content-lg-around",
  LgEvenly: "justify-content-lg-evenly",
  XlStart: "justify-content-xl-start",
  XlEnd: "justify-content-xl-end",
  XlCenter: "justify-content-xl-center",
  XlBetween: "justify-content-xl-between",
  XlAround: "justify-content-xl-around",
  XlEvenly: "justify-content-xl-evenly",
  XxlStart: "justify-content-xxl-start",
  XxlEnd: "justify-content-xxl-end",
  XxlCenter: "justify-content-xxl-center",
  XxlBetween: "justify-content-xxl-between",
  XxlAround: "justify-content-xxl-around",
  XxlEvenly: "justify-content-xxl-evenly"
}, co = {
  Start: "align-content-start",
  End: "align-content-end",
  Center: "align-content-center",
  Between: "align-content-between",
  Around: "align-content-around",
  Stretch: "align-content-stretch",
  SmStart: "align-content-sm-start",
  SmEnd: "align-content-sm-end",
  SmCenter: "align-content-sm-center",
  SmBetween: "align-content-sm-between",
  SmAround: "align-content-sm-around",
  SmStretch: "align-content-sm-stretch",
  MdStart: "align-content-md-start",
  MdEnd: "align-content-md-end",
  MdCenter: "align-content-md-center",
  MdBetween: "align-content-md-between",
  MdAround: "align-content-md-around",
  MdStretch: "align-content-md-stretch",
  LgStart: "align-content-lg-start",
  LgEnd: "align-content-lg-end",
  LgCenter: "align-content-lg-center",
  LgBetween: "align-content-lg-between",
  LgAround: "align-content-lg-around",
  LgStretch: "align-content-lg-stretch",
  XlStart: "align-content-xl-start",
  XlEnd: "align-content-xl-end",
  XlCenter: "align-content-xl-center",
  XlBetween: "align-content-xl-between",
  XlAround: "align-content-xl-around",
  XlStretch: "align-content-xl-stretch",
  XxlStart: "align-content-xxl-start",
  XxlEnd: "align-content-xxl-end",
  XxlCenter: "align-content-xxl-center",
  XxlBetween: "align-content-xxl-between",
  XxlAround: "align-content-xxl-around",
  XxlStretch: "align-content-xxl-stretch"
}, fo = {
  Gap0: "gap-0",
  Gap1: "gap-1",
  Gap2: "gap-2",
  Gap3: "gap-3",
  Gap4: "gap-4",
  Gap5: "gap-5",
  GapSm0: "gap-sm-0",
  GapSm1: "gap-sm-1",
  GapSm2: "gap-sm-2",
  GapSm3: "gap-sm-3",
  GapSm4: "gap-sm-4",
  GapSm5: "gap-sm-5",
  GapMd0: "gap-md-0",
  GapMd1: "gap-md-1",
  GapMd2: "gap-md-2",
  GapMd3: "gap-md-3",
  GapMd4: "gap-md-4",
  GapMd5: "gap-md-5",
  GapLg0: "gap-lg-0",
  GapLg1: "gap-lg-1",
  GapLg2: "gap-lg-2",
  GapLg3: "gap-lg-3",
  GapLg4: "gap-lg-4",
  GapLg5: "gap-lg-5",
  GapXl0: "gap-xl-0",
  GapXl1: "gap-xl-1",
  GapXl2: "gap-xl-2",
  GapXl3: "gap-xl-3",
  GapXl4: "gap-xl-4",
  GapXl5: "gap-xl-5",
  GapXxl0: "gap-xxl-0",
  GapXxl1: "gap-xxl-1",
  GapXxl2: "gap-xxl-2",
  GapXxl3: "gap-xxl-3",
  GapXxl4: "gap-xxl-4",
  GapXxl5: "gap-xxl-5"
}, He = {
  Order0: "order-0",
  Order1: "order-1",
  Order2: "order-2",
  Order3: "order-3",
  Order4: "order-4",
  Order5: "order-5",
  OrderFirst: "order-first",
  OrderLast: "order-last",
  OrderSm0: "order-sm-0",
  OrderSm1: "order-sm-1",
  OrderSm2: "order-sm-2",
  OrderSm3: "order-sm-3",
  OrderSm4: "order-sm-4",
  OrderSm5: "order-sm-5",
  OrderSmFirst: "order-sm-first",
  OrderSmLast: "order-sm-last",
  OrderMd0: "order-md-0",
  OrderMd1: "order-md-1",
  OrderMd2: "order-md-2",
  OrderMd3: "order-md-3",
  OrderMd4: "order-md-4",
  OrderMd5: "order-md-5",
  OrderMdFirst: "order-md-first",
  OrderMdLast: "order-md-last",
  OrderLg0: "order-lg-0",
  OrderLg1: "order-lg-1",
  OrderLg2: "order-lg-2",
  OrderLg3: "order-lg-3",
  OrderLg4: "order-lg-4",
  OrderLg5: "order-lg-5",
  OrderLgFirst: "order-lg-first",
  OrderLgLast: "order-lg-last",
  OrderXl0: "order-xl-0",
  OrderXl1: "order-xl-1",
  OrderXl2: "order-xl-2",
  OrderXl3: "order-xl-3",
  OrderXl4: "order-xl-4",
  OrderXl5: "order-xl-5",
  OrderXlFirst: "order-xl-first",
  OrderXlLast: "order-xl-last",
  OrderXxl0: "order-xxl-0",
  OrderXxl1: "order-xxl-1",
  OrderXxl2: "order-xxl-2",
  OrderXxl3: "order-xxl-3",
  OrderXxl4: "order-xxl-4",
  OrderXxl5: "order-xxl-5",
  OrderXxlFirst: "order-xxl-first",
  OrderXxlLast: "order-xxl-last"
}, uo = {
  Grow0: "flex-grow-0",
  Grow1: "flex-grow-1",
  SmGrow0: "flex-sm-grow-0",
  SmGrow1: "flex-sm-grow-1",
  MdGrow0: "flex-md-grow-0",
  MdGrow1: "flex-md-grow-1",
  LgGrow0: "flex-lg-grow-0",
  LgGrow1: "flex-lg-grow-1",
  XlGrow0: "flex-xl-grow-0",
  XlGrow1: "flex-xl-grow-1",
  XxlGrow0: "flex-xxl-grow-0",
  XxlGrow1: "flex-xxl-grow-1"
}, mo = {
  Shrink0: "flex-shrink-0",
  Shrink1: "flex-shrink-1",
  SmShrink0: "flex-sm-shrink-0",
  SmShrink1: "flex-sm-shrink-1",
  MdShrink0: "flex-md-shrink-0",
  MdShrink1: "flex-md-shrink-1",
  LgShrink0: "flex-lg-shrink-0",
  LgShrink1: "flex-lg-shrink-1",
  XlShrink0: "flex-xl-shrink-0",
  XlShrink1: "flex-xl-shrink-1",
  XxlShrink0: "flex-xxl-shrink-0",
  XxlShrink1: "flex-xxl-shrink-1"
}, po = {
  Fill: "flex-fill",
  SmFill: "flex-sm-fill",
  MdFill: "flex-md-fill",
  LgFill: "flex-lg-fill",
  XlFill: "flex-xl-fill",
  XxlFill: "flex-xxl-fill"
}, go = {
  RowCols1: "row-cols-1",
  RowCols2: "row-cols-2",
  RowCols3: "row-cols-3",
  RowCols4: "row-cols-4",
  RowCols5: "row-cols-5",
  RowCols6: "row-cols-6",
  RowColsAuto: "row-cols-auto",
  RowColsSm1: "row-cols-sm-1",
  RowColsSm2: "row-cols-sm-2",
  RowColsSm3: "row-cols-sm-3",
  RowColsSm4: "row-cols-sm-4",
  RowColsSm5: "row-cols-sm-5",
  RowColsSm6: "row-cols-sm-6",
  RowColsSmAuto: "row-cols-sm-auto",
  RowColsMd1: "row-cols-md-1",
  RowColsMd2: "row-cols-md-2",
  RowColsMd3: "row-cols-md-3",
  RowColsMd4: "row-cols-md-4",
  RowColsMd5: "row-cols-md-5",
  RowColsMd6: "row-cols-md-6",
  RowColsMdAuto: "row-cols-md-auto",
  RowColsLg1: "row-cols-lg-1",
  RowColsLg2: "row-cols-lg-2",
  RowColsLg3: "row-cols-lg-3",
  RowColsLg4: "row-cols-lg-4",
  RowColsLg5: "row-cols-lg-5",
  RowColsLg6: "row-cols-lg-6",
  RowColsLgAuto: "row-cols-lg-auto",
  RowColsXl1: "row-cols-xl-1",
  RowColsXl2: "row-cols-xl-2",
  RowColsXl3: "row-cols-xl-3",
  RowColsXl4: "row-cols-xl-4",
  RowColsXl5: "row-cols-xl-5",
  RowColsXl6: "row-cols-xl-6",
  RowColsXlAuto: "row-cols-xl-auto",
  RowColsXxl1: "row-cols-xxl-1",
  RowColsXxl2: "row-cols-xxl-2",
  RowColsXxl3: "row-cols-xxl-3",
  RowColsXxl4: "row-cols-xxl-4",
  RowColsXxl5: "row-cols-xxl-5",
  RowColsXxl6: "row-cols-xxl-6",
  RowColsXxlAuto: "row-cols-xxl-auto"
}, xo = {
  G0: "g-0",
  G1: "g-1",
  G2: "g-2",
  G3: "g-3",
  G4: "g-4",
  G5: "g-5",
  GSm0: "g-sm-0",
  GSm1: "g-sm-1",
  GSm2: "g-sm-2",
  GSm3: "g-sm-3",
  GSm4: "g-sm-4",
  GSm5: "g-sm-5",
  GMd0: "g-md-0",
  GMd1: "g-md-1",
  GMd2: "g-md-2",
  GMd3: "g-md-3",
  GMd4: "g-md-4",
  GMd5: "g-md-5",
  GLg0: "g-lg-0",
  GLg1: "g-lg-1",
  GLg2: "g-lg-2",
  GLg3: "g-lg-3",
  GLg4: "g-lg-4",
  GLg5: "g-lg-5",
  GXl0: "g-xl-0",
  GXl1: "g-xl-1",
  GXl2: "g-xl-2",
  GXl3: "g-xl-3",
  GXl4: "g-xl-4",
  GXl5: "g-xl-5",
  GXxl0: "g-xxl-0",
  GXxl1: "g-xxl-1",
  GXxl2: "g-xxl-2",
  GXxl3: "g-xxl-3",
  GXxl4: "g-xxl-4",
  GXxl5: "g-xxl-5"
}, wo = {
  Col1: "col-1",
  Col2: "col-2",
  Col3: "col-3",
  Col4: "col-4",
  Col5: "col-5",
  Col6: "col-6",
  Col7: "col-7",
  Col8: "col-8",
  Col9: "col-9",
  Col10: "col-10",
  Col11: "col-11",
  Col12: "col-12",
  ColAuto: "col-auto",
  ColSm1: "col-sm-1",
  ColSm2: "col-sm-2",
  ColSm3: "col-sm-3",
  ColSm4: "col-sm-4",
  ColSm5: "col-sm-5",
  ColSm6: "col-sm-6",
  ColSm7: "col-sm-7",
  ColSm8: "col-sm-8",
  ColSm9: "col-sm-9",
  ColSm10: "col-sm-10",
  ColSm11: "col-sm-11",
  ColSm12: "col-sm-12",
  ColSmAuto: "col-sm-auto",
  ColMd1: "col-md-1",
  ColMd2: "col-md-2",
  ColMd3: "col-md-3",
  ColMd4: "col-md-4",
  ColMd5: "col-md-5",
  ColMd6: "col-md-6",
  ColMd7: "col-md-7",
  ColMd8: "col-md-8",
  ColMd9: "col-md-9",
  ColMd10: "col-md-10",
  ColMd11: "col-md-11",
  ColMd12: "col-md-12",
  ColMdAuto: "col-md-auto",
  ColLg1: "col-lg-1",
  ColLg2: "col-lg-2",
  ColLg3: "col-lg-3",
  ColLg4: "col-lg-4",
  ColLg5: "col-lg-5",
  ColLg6: "col-lg-6",
  ColLg7: "col-lg-7",
  ColLg8: "col-lg-8",
  ColLg9: "col-lg-9",
  ColLg10: "col-lg-10",
  ColLg11: "col-lg-11",
  ColLg12: "col-lg-12",
  ColLgAuto: "col-lg-auto",
  ColXl1: "col-xl-1",
  ColXl2: "col-xl-2",
  ColXl3: "col-xl-3",
  ColXl4: "col-xl-4",
  ColXl5: "col-xl-5",
  ColXl6: "col-xl-6",
  ColXl7: "col-xl-7",
  ColXl8: "col-xl-8",
  ColXl9: "col-xl-9",
  ColXl10: "col-xl-10",
  ColXl11: "col-xl-11",
  ColXl12: "col-xl-12",
  ColXlAuto: "col-xl-auto",
  ColXxl1: "col-xxl-1",
  ColXxl2: "col-xxl-2",
  ColXxl3: "col-xxl-3",
  ColXxl4: "col-xxl-4",
  ColXxl5: "col-xxl-5",
  ColXxl6: "col-xxl-6",
  ColXxl7: "col-xxl-7",
  ColXxl8: "col-xxl-8",
  ColXxl9: "col-xxl-9",
  ColXxl10: "col-xxl-10",
  ColXxl11: "col-xxl-11",
  ColXxl12: "col-xxl-12",
  ColXxlAuto: "col-xxl-auto"
}, So = {
  Offset1: "offset-1",
  Offset2: "offset-2",
  Offset3: "offset-3",
  Offset4: "offset-4",
  Offset5: "offset-5",
  Offset6: "offset-6",
  Offset7: "offset-7",
  Offset8: "offset-8",
  Offset9: "offset-9",
  Offset10: "offset-10",
  Offset11: "offset-11",
  OffsetSm1: "offset-sm-1",
  OffsetSm2: "offset-sm-2",
  OffsetSm3: "offset-sm-3",
  OffsetSm4: "offset-sm-4",
  OffsetSm5: "offset-sm-5",
  OffsetSm6: "offset-sm-6",
  OffsetSm7: "offset-sm-7",
  OffsetSm8: "offset-sm-8",
  OffsetSm9: "offset-sm-9",
  OffsetSm10: "offset-sm-10",
  OffsetSm11: "offset-sm-11",
  OffsetMd1: "offset-md-1",
  OffsetMd2: "offset-md-2",
  OffsetMd3: "offset-md-3",
  OffsetMd4: "offset-md-4",
  OffsetMd5: "offset-md-5",
  OffsetMd6: "offset-md-6",
  OffsetMd7: "offset-md-7",
  OffsetMd8: "offset-md-8",
  OffsetMd9: "offset-md-9",
  OffsetMd10: "offset-md-10",
  OffsetMd11: "offset-md-11",
  OffsetLg1: "offset-lg-1",
  OffsetLg2: "offset-lg-2",
  OffsetLg3: "offset-lg-3",
  OffsetLg4: "offset-lg-4",
  OffsetLg5: "offset-lg-5",
  OffsetLg6: "offset-lg-6",
  OffsetLg7: "offset-lg-7",
  OffsetLg8: "offset-lg-8",
  OffsetLg9: "offset-lg-9",
  OffsetLg10: "offset-lg-10",
  OffsetLg11: "offset-lg-11",
  OffsetXl1: "offset-xl-1",
  OffsetXl2: "offset-xl-2",
  OffsetXl3: "offset-xl-3",
  OffsetXl4: "offset-xl-4",
  OffsetXl5: "offset-xl-5",
  OffsetXl6: "offset-xl-6",
  OffsetXl7: "offset-xl-7",
  OffsetXl8: "offset-xl-8",
  OffsetXl9: "offset-xl-9",
  OffsetXl10: "offset-xl-10",
  OffsetXl11: "offset-xl-11",
  OffsetXxl1: "offset-xxl-1",
  OffsetXxl2: "offset-xxl-2",
  OffsetXxl3: "offset-xxl-3",
  OffsetXxl4: "offset-xxl-4",
  OffsetXxl5: "offset-xxl-5",
  OffsetXxl6: "offset-xxl-6",
  OffsetXxl7: "offset-xxl-7",
  OffsetXxl8: "offset-xxl-8",
  OffsetXxl9: "offset-xxl-9",
  OffsetXxl10: "offset-xxl-10",
  OffsetXxl11: "offset-xxl-11"
}, J = (e) => e ? Array.isArray(e) ? e : [e] : [], Ln = ({
  children: e,
  cols: o,
  gutter: t,
  alignItems: s,
  justifyContent: n,
  className: l
}) => {
  const r = [
    ...J(o),
    ...J(t),
    ...J(s),
    ...J(n)
  ], d = [
    { prop: o, set: new Set(Object.values(go)) },
    { prop: t, set: new Set(Object.values(xo)) },
    { prop: s, set: new Set(Object.values(Ae)) },
    { prop: n, set: new Set(Object.values(We)) }
  ], f = ((l == null ? void 0 : l.split(" ").filter(Boolean)) ?? []).filter(
    (u) => !d.some(({ prop: g, set: w }) => g && w.has(u))
  ), a = /* @__PURE__ */ new Set([...r, ...f]), m = [
    "row",
    ...new Set(
      [...a].filter((u) => u !== "row")
    )
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: m, children: e });
}, Q = (e) => e ? Array.isArray(e) ? e : [e] : [], Bn = ({
  children: e,
  col: o,
  order: t,
  offset: s,
  alignSelf: n,
  className: l
}) => {
  const r = [
    ...Q(o),
    ...Q(t),
    ...Q(s),
    ...Q(n)
  ], d = [
    { prop: o, set: new Set(Object.values(wo)) },
    { prop: o, set: new Set(Object.values({ default: "col" })) },
    { prop: n, set: new Set(Object.values(Fe)) },
    { prop: t, set: new Set(Object.values(He)) },
    { prop: s, set: new Set(Object.values(So)) }
  ], f = ((l == null ? void 0 : l.split(" ").filter(Boolean)) ?? []).filter(
    (u) => !d.some(({ prop: g, set: w }) => g && w.has(u))
  ), a = /* @__PURE__ */ new Set([...r, ...f]), m = [
    "col",
    ...new Set(
      [...a].filter((u) => u !== "col")
    )
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: m, children: e });
}, bo = ({ children: e }) => /* @__PURE__ */ c("header", { className: "layout-header", children: e }), ho = ({ children: e }) => /* @__PURE__ */ c("aside", { className: "layout-aside", children: e }), _e = tt(
  ({ children: e }, o) => /* @__PURE__ */ c(
    "main",
    {
      ref: o,
      className: "layout-content",
      children: e
    }
  )
);
_e.displayName = "LayoutContent";
const Co = ({ children: e }) => /* @__PURE__ */ c("footer", { className: "layout-footer", children: e }), se = (({ type: e, children: o }) => /* @__PURE__ */ c("div", { className: `layout ${e} d-grid overflow-hidden`, children: o }));
se.Header = bo;
se.Sidebar = ho;
se.Content = _e;
se.Footer = Co;
const vo = (e, o, t) => {
  switch (o.type) {
    case "TOGGLE_ITEM": {
      const s = o.payload, n = e.openItems.includes(s);
      return t ? {
        openItems: n ? e.openItems.filter((l) => l !== s) : [...e.openItems, s]
      } : {
        openItems: n ? [] : [s]
      };
    }
    case "OPEN_ITEM": {
      const s = o.payload;
      return e.openItems.includes(s) ? e : t ? { openItems: [...e.openItems, s] } : { openItems: [s] };
    }
    case "RESET":
      return { openItems: [] };
    default:
      return e;
  }
}, $e = V(null), yo = () => {
  const e = K($e);
  if (!e)
    throw new Error("useAccordionContext must be used within <AccordionProvider>");
  return e;
}, Oo = ({ children: e, stayOpen: o = !1 }) => {
  const [t, s] = Re(
    (d, i) => vo(d, i, o),
    { openItems: [] }
  ), n = P((d) => {
    s({ type: "TOGGLE_ITEM", payload: d });
  }, []), l = P((d) => {
    s({ type: "OPEN_ITEM", payload: d });
  }, []), r = {
    openItems: t.openItems,
    toggleItem: n,
    openItem: l,
    stayOpen: o
  };
  return /* @__PURE__ */ c($e.Provider, { value: r, children: e });
}, Lo = ({
  children: e,
  title: o,
  open: t = !1,
  eventKey: s,
  className: n,
  ...l
}) => {
  const { openItems: r, toggleItem: d, openItem: i } = yo(), f = he(), a = s ?? f, m = he(), u = r.includes(a), g = I(!1);
  W(() => {
    !t || g.current || (g.current = !0, i(a));
  }, [t, a, i]);
  const w = [
    "accordion-item",
    ...new Set(
      (n ?? "").split(/\s+/).filter(Boolean).filter((b) => b !== "accordion-item")
    )
  ].join(" ");
  return /* @__PURE__ */ N("div", { className: w, ...l, children: [
    /* @__PURE__ */ c("h2", { className: "accordion-header", children: /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        id: m,
        className: `accordion-button${u ? "" : " collapsed"}`,
        onClick: () => d(a),
        "aria-expanded": u,
        "aria-controls": a,
        children: o
      }
    ) }),
    /* @__PURE__ */ c(
      "div",
      {
        id: a,
        role: "region",
        "aria-labelledby": m,
        className: `accordion-collapse collapse${u ? " show" : ""}`,
        children: /* @__PURE__ */ c("div", { className: "accordion-body", children: e })
      }
    )
  ] });
}, Bo = /* @__PURE__ */ new Set(["accordion-flush"]), Xo = (({
  children: e,
  stayOpen: o = !1,
  flush: t,
  className: s,
  ...n
}) => {
  const l = [
    ...t ? ["accordion-flush"] : []
  ], r = [{ prop: t, set: Bo }], i = ((s == null ? void 0 : s.split(/\s+/).filter(Boolean)) ?? []).filter(
    (a) => a !== "accordion" && !r.some(({ prop: m, set: u }) => m && u.has(a))
  ), f = [
    "accordion",
    .../* @__PURE__ */ new Set([...l, ...i])
  ].join(" ");
  return /* @__PURE__ */ c(Oo, { stayOpen: o, children: /* @__PURE__ */ c("div", { className: f, ...n, children: e }) });
});
Xo.Item = Lo;
const Eo = ({
  children: e,
  text: o,
  path: t,
  className: s,
  isCurrent: n = !1,
  ...l
}) => {
  const r = e ?? o, d = [
    "breadcrumb-item",
    ...new Set(
      (s ?? "").split(/\s+/).filter(Boolean).filter((i) => i !== "breadcrumb-item")
    )
  ].join(" ");
  return /* @__PURE__ */ c(
    "li",
    {
      className: `${d}${n ? " active" : ""}`,
      "aria-current": n ? "page" : void 0,
      ...l,
      children: t && !n ? /* @__PURE__ */ c("a", { href: t, children: r }) : r
    }
  );
}, ko = (({
  children: e,
  className: o,
  divider: t,
  ...s
}) => {
  const n = [
    "breadcrumb",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((r) => r !== "breadcrumb")
    )
  ].join(" "), l = t !== void 0 ? { "--bs-breadcrumb-divider": `'${t}'` } : void 0;
  return /* @__PURE__ */ c(
    "nav",
    {
      "aria-label": "breadcrumb",
      style: l,
      children: /* @__PURE__ */ c("ol", { className: n, ...s, children: e })
    }
  );
});
ko.Item = Eo;
const To = {
  Primary: "text-bg-primary",
  Secondary: "text-bg-secondary",
  Success: "text-bg-success",
  Danger: "text-bg-danger",
  Warning: "text-bg-warning",
  Info: "text-bg-info",
  Light: "text-bg-light",
  Dark: "text-bg-dark"
}, ve = {
  Top: "card-image-top",
  Bottom: "card-image-bottom"
}, Ro = ({
  children: e,
  className: o
}) => {
  const t = [
    "card-body",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "card-body")
    )
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, No = (e) => e ? Array.isArray(e) ? e : [e] : [], jo = ({
  className: e,
  placement: o = ve.Top,
  alt: t = "",
  src: s
}) => {
  const n = [
    ...No(o)
  ], l = [
    { prop: o, set: new Set(Object.values(ve)) }
  ], d = ((e == null ? void 0 : e.split(" ").filter(Boolean)) ?? []).filter(
    (f) => !l.some(({ prop: a, set: m }) => a && m.has(f))
  ), i = [
    "card-image",
    ...new Set([...n, ...d].filter((f) => f !== "card-image"))
  ].join(" ");
  return /* @__PURE__ */ c("img", { className: i, alt: t, src: s });
}, Po = ({
  children: e,
  className: o
}) => {
  const t = [
    "card-header",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "card-header")
    )
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, Mo = ({
  children: e,
  className: o
}) => {
  const t = [
    "card-footer",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "card-footer")
    )
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, Do = ({
  el: e,
  children: o,
  className: t,
  ...s
}) => {
  const n = [
    "card-title",
    ...new Set(
      (t ?? "").split(/\s+/).filter(Boolean).filter((r) => r !== "card-title")
    )
  ].join(" ");
  return E(e || "h5", { ...s, className: n }, o);
}, Io = ({
  children: e,
  className: o
}) => {
  const t = [
    "card-text",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "card-text")
    )
  ].join(" ");
  return /* @__PURE__ */ c("p", { className: t, children: e });
}, Go = new Set(Object.values(To)), z = (({
  children: e,
  className: o,
  color: t,
  ...s
}) => {
  const n = [
    ...t ? [t] : []
  ], l = [{ prop: t, set: Go }], d = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (f) => !l.some(({ prop: a, set: m }) => a && m.has(f))
  ), i = [
    "card",
    ...new Set([...n, ...d].filter((f) => f !== "card"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: i, ...s, children: e });
});
z.Header = Po;
z.Body = Ro;
z.Footer = Mo;
z.Image = jo;
z.Title = Do;
z.Text = Io;
const Ao = (e, o) => {
  switch (o.type) {
    case "TOGGLE":
      return { ...e, isOpen: !e.isOpen };
    case "CLOSE":
      return { ...e, isOpen: !1 };
    case "SET_DIRECTION":
      return { ...e, direction: o.payload };
    default:
      return e;
  }
}, ze = V(null), ne = () => {
  const e = K(ze);
  if (!e)
    throw new Error("useDropdownContext must be used inside <DropdownProvider>");
  return e;
}, Fo = ({
  children: e,
  defaultDirection: o = F.DropDownStart
}) => {
  const [t, s] = Re(Ao, {
    isOpen: !1,
    direction: o
  }), n = {
    isOpen: t.isOpen,
    direction: t.direction,
    toggle: () => s({ type: "TOGGLE" }),
    close: () => s({ type: "CLOSE" }),
    setDirection: (l) => s({ type: "SET_DIRECTION", payload: l })
  };
  return /* @__PURE__ */ c(ze.Provider, { value: n, children: e });
}, Wo = ({
  el: e,
  children: o,
  className: t,
  disabled: s = !1,
  active: n = !1,
  onClick: l,
  ...r
}) => {
  const { close: d } = ne(), i = e || "button", f = () => {
    l && l(), d();
  }, a = [
    "dropdown-item",
    ...new Set(
      (t ?? "").split(/\s+/).filter(Boolean).filter((u) => u !== "dropdown-item")
    )
  ];
  n && a.push("active"), s && a.push("disabled");
  const m = a.join(" ");
  return /* @__PURE__ */ c("li", { children: E(i, { ...r, className: m, onClick: f }, o) });
}, F = {
  DropDownStart: "dropdown-start",
  DropDownCenter: "dropdown-center",
  DropDownEnd: "dropdown-end",
  DropUpStart: "dropup-start",
  DropUpCenter: "dropup-center",
  DropUpEnd: "dropup-end",
  DropStart: "dropstart",
  DropEnd: "dropend"
}, Ho = (e) => {
  switch (e) {
    case F.DropDownStart:
      return { inset: "100% auto auto 0", transform: "translate(0, 0)" };
    case F.DropDownCenter:
      return { inset: "100% auto auto 50%", transform: "translate(-50%, 0)" };
    case F.DropDownEnd:
      return { inset: "100% 0 auto auto", transform: "translate(0, 0)" };
    case F.DropUpStart:
      return { inset: "auto auto 100% 0", transform: "translate(0, 0)" };
    case F.DropUpCenter:
      return { inset: "auto auto 100% 50%", transform: "translate(-50%, 0)" };
    case F.DropUpEnd:
      return { inset: "auto 0 100% auto", transform: "translate(0, 0)" };
    case F.DropStart:
      return { inset: "0 100% auto auto", transform: "translate(0, 0)" };
    case F.DropEnd:
      return { inset: "0 auto auto 100%", transform: "translate(0, 0)" };
    default:
      return {};
  }
}, _o = ({
  children: e,
  className: o,
  style: t,
  ...s
}) => {
  const { isOpen: n, direction: l } = ne(), r = {
    ...Ho(l),
    ...t
  }, d = [
    "dropdown-menu",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((i) => i !== "dropdown-menu")
    )
  ].join(" ");
  return /* @__PURE__ */ c("ul", { className: `${d}${n ? " show" : ""}`, style: r, ...s, children: e });
}, $o = ({
  children: e,
  className: o = "",
  color: t = me.Secondary,
  size: s,
  disabled: n = !1,
  active: l = !1,
  split: r = !1,
  onMainClick: d,
  ...i
}) => {
  const { toggle: f, isOpen: a } = ne(), m = `dropdown-toggle ${r ? "dropdown-toggle-split" : ""} ${o}`.trim();
  return /* @__PURE__ */ N(q, { children: [
    r && /* @__PURE__ */ c(
      de,
      {
        color: t,
        size: s,
        disabled: n,
        onClick: d,
        className: "main-btn",
        children: e
      }
    ),
    /* @__PURE__ */ c(
      de,
      {
        className: m,
        color: t,
        size: s,
        disabled: n,
        active: l,
        "aria-expanded": a,
        onClick: f,
        ...i,
        children: r ? /* @__PURE__ */ c("span", { className: "visually-hidden", children: "Toggle Dropdown" }) : e
      }
    )
  ] });
}, zo = ({ children: e, className: o, direction: t }) => {
  const { close: s, isOpen: n } = ne(), l = I(null);
  W(() => {
    const i = (f) => {
      l.current && !l.current.contains(f.target) && s();
    };
    return n && document.addEventListener("mousedown", i), () => {
      document.removeEventListener("mousedown", i);
    };
  }, [n, s]);
  const r = [
    "btn-group",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((i) => i !== "btn-group")
    )
  ];
  t != null && t.startsWith("dropdown") && r.push("dropdown"), t != null && t.startsWith("dropup") && r.push("dropup"), t != null && t.startsWith("dropstart") && r.push("dropstart"), t != null && t.startsWith("dropend") && r.push("dropend");
  const d = r.join(" ");
  return /* @__PURE__ */ c("div", { className: d, ref: l, children: e });
}, xe = (({
  children: e,
  className: o,
  direction: t
}) => /* @__PURE__ */ c(Fo, { defaultDirection: t, children: /* @__PURE__ */ c(zo, { className: o, direction: t, children: e }) }));
xe.Toggle = $o;
xe.Menu = _o;
xe.Item = Wo;
const Yo = {
  Primary: "list-group-item-primary",
  Secondary: "list-group-item-secondary",
  Success: "list-group-item-success",
  Danger: "list-group-item-danger",
  Warning: "list-group-item-warning",
  Info: "list-group-item-info",
  Light: "list-group-item-light",
  Dark: "list-group-item-dark"
}, Ye = V(null), Uo = () => {
  const e = K(Ye);
  if (!e) throw new Error("ListGroup.Item must be used inside a <ListGroup>");
  return e;
}, qo = Ye.Provider, Vo = new Set(Object.values(Yo)), Ko = ({
  el: e,
  children: o,
  color: t,
  className: s,
  disabled: n = !1,
  active: l = !1,
  ...r
}) => {
  const { parentTag: d } = Uo(), f = e || (d === "ul" || d === "ol" ? "li" : "button"), a = [
    ...t ? [t] : []
  ], m = [{ prop: t, set: Vo }], g = ((s == null ? void 0 : s.split(/\s+/).filter(Boolean)) ?? []).filter(
    (X) => !m.some(({ prop: k, set: p }) => k && p.has(X))
  ), w = [
    "list-group-item",
    ...new Set([...a, ...g].filter((X) => X !== "list-group-item"))
  ];
  (f === "a" || f === "button") && w.push("list-group-item-action"), l && w.push("active"), n && w.push("disabled");
  const b = w.join(" ");
  return E(f, { ...r, className: b }, o);
}, Jo = (({
  el: e,
  children: o,
  className: t,
  ...s
}) => {
  const n = e || "ul", l = [
    "list-group",
    ...new Set(
      (t ?? "").split(/\s+/).filter(Boolean).filter((r) => r !== "list-group")
    )
  ].join(" ");
  return /* @__PURE__ */ c(qo, { value: { parentTag: n }, children: E(n, { ...s, className: l }, o) });
});
Jo.Item = Ko;
const Qo = {
  Sm: "modal-sm",
  Lg: "modal-lg",
  Xl: "modal-xl"
}, Zo = {
  Always: "modal-fullscreen",
  SmDown: "modal-fullscreen-sm-down",
  MdDown: "modal-fullscreen-md-down",
  LgDown: "modal-fullscreen-lg-down",
  XlDown: "modal-fullscreen-xl-down",
  XxlDown: "modal-fullscreen-xxl-down"
}, ye = (e) => e ? Array.isArray(e) ? e : [e] : [], es = ({
  children: e,
  className: o,
  size: t,
  scrollable: s = !1,
  centered: n = !1,
  fullscreen: l = !1
}) => {
  const r = [
    ...ye(t),
    ...l === !0 ? ["modal-fullscreen"] : ye(l)
  ].filter(Boolean), d = [
    { prop: t, set: new Set(Object.values(Qo)) },
    { prop: l, set: new Set(Object.values(Zo)) }
  ], f = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (u) => !d.some(({ prop: g, set: w }) => g && w.has(u)) && (!s || u !== "modal-dialog-scrollable") && (!n || u !== "modal-dialog-centered")
  ), a = [
    "modal-dialog",
    s ? "modal-dialog-scrollable" : "",
    n ? "modal-dialog-centered" : "",
    .../* @__PURE__ */ new Set([...r, ...f])
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ c("div", { className: a, onClick: (u) => {
    u.stopPropagation();
  }, children: /* @__PURE__ */ c("div", { className: "modal-content", children: e }) });
}, ts = ({
  children: e,
  className: o
}) => {
  const t = [
    "modal-body",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "modal-body"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, os = ({
  children: e,
  className: o
}) => {
  const t = [
    "modal-header",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "modal-header"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, ss = ({
  children: e,
  className: o
}) => {
  const t = [
    "modal-footer",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "modal-footer"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, le = (({
  children: e,
  className: o,
  show: t = !1,
  onClose: s,
  backdropClose: n = !0,
  ...l
}) => {
  const i = "opacity 0.15s linear", f = "opacity 0.15s linear", [a, m] = T.useState(!1), [u, g] = T.useState(!1), w = T.useMemo(() => [
    "modal fade",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((p) => p !== "modal fade"))
  ].join(" "), [o]);
  T.useEffect(() => {
    if (t) {
      m(!0);
      const p = setTimeout(() => g(!0), 10);
      return () => clearTimeout(p);
    } else {
      g(!1);
      const p = setTimeout(() => m(!1), 150);
      return () => clearTimeout(p);
    }
  }, [t]), T.useEffect(() => {
    if (t) {
      const p = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden", document.body.style.paddingRight = `${p}px`;
    } else
      document.body.style.overflow = "", document.body.style.paddingRight = "";
    return () => {
      document.body.style.overflow = "", document.body.style.paddingRight = "";
    };
  }, [t]), T.useEffect(() => {
    const p = (y) => {
      y.key === "Escape" && t && s && s();
    };
    if (t)
      return document.addEventListener("keydown", p), () => document.removeEventListener("keydown", p);
  }, [t, s]);
  const b = T.useCallback((p) => {
    n && s && p.target === p.currentTarget && s();
  }, [n, s]), X = T.useMemo(() => ({
    display: a ? "block" : "none",
    transition: i,
    opacity: u ? 1 : 0
  }), [a, u]), k = T.useMemo(() => ({
    transition: f,
    opacity: u ? 0.5 : 0
  }), [u]);
  return /* @__PURE__ */ N(q, { children: [
    a && /* @__PURE__ */ c(
      "div",
      {
        className: `${w}${u ? " show" : ""}`,
        style: X,
        onClick: b,
        "aria-modal": "true",
        role: "dialog",
        tabIndex: -1,
        ...l,
        children: e
      }
    ),
    a && /* @__PURE__ */ c(
      "div",
      {
        className: `modal-backdrop fade${u ? " show" : ""}`,
        style: k
      }
    )
  ] });
});
le.Dialog = es;
le.Header = os;
le.Body = ts;
le.Footer = ss;
const ns = ({
  children: e,
  className: o,
  ...t
}) => {
  const s = [
    "nav-item",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((n) => n !== "nav-item"))
  ].join(" ");
  return /* @__PURE__ */ c("li", { className: s, ...t, children: e });
}, Ue = V(null), qe = () => K(Ue), ls = () => {
  const e = qe();
  if (!e)
    throw new Error("Tabs compound components must be used within Tabs");
  return e;
}, rs = ({
  as: e,
  children: o,
  className: t,
  to: s,
  active: n,
  disabled: l,
  eventKey: r,
  onClick: d,
  href: i,
  ...f
}) => {
  const a = qe(), m = a && r ? a.activeKey === r : n, u = [
    "nav-link",
    ...new Set((t ?? "").split(/\s+/).filter(Boolean).filter((p) => !["nav-link", "active"].includes(p)))
  ];
  m && u.push("active"), l && u.push("disabled");
  const g = u.join(" "), w = m ? "page" : void 0, b = (p) => {
    if (l) {
      p.preventDefault();
      return;
    }
    a && r && (p.preventDefault(), a.onSelect(r)), d && (p.preventDefault(), d(p));
  }, X = i !== void 0 ? i : s, k = s ?? i ?? "#";
  return e ? T.createElement(
    e,
    {
      ...f,
      to: k,
      className: g,
      "aria-current": w,
      onClick: b,
      ...l ? { tabIndex: -1, "aria-disabled": !0 } : {},
      ...r ? { "data-bs-toggle": "tab", role: "button" } : {}
    },
    o
  ) : /* @__PURE__ */ c(
    "a",
    {
      ...X ? { href: X } : {},
      className: g,
      "aria-current": w,
      onClick: b,
      ...l ? { tabIndex: -1, "aria-disabled": !0 } : {},
      ...r ? { "data-bs-toggle": "tab", role: "button" } : X ? {} : { role: "button" },
      ...f,
      children: o
    }
  );
}, Ve = V(void 0), Ke = () => K(Ve), fe = () => {
  const e = Ke();
  if (!e)
    throw new Error("useNavbar must be used within a <Navbar> component");
  return e;
}, as = ({ children: e, defaultExpanded: o = !1 }) => {
  const [t, s] = H(o), n = () => s((l) => !l);
  return /* @__PURE__ */ c(Ve.Provider, { value: { expanded: t, toggle: n }, children: e });
}, Je = (({
  children: e,
  className: o,
  ...t
}) => {
  const n = [
    ...Ke() !== void 0 ? ["navbar-nav"] : ["nav"],
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((l) => !["nav", "navbar-nav"].includes(l)))
  ].join(" ");
  return /* @__PURE__ */ c("ul", { className: n, ...t, children: e });
});
Je.Item = ns;
Je.Link = rs;
const Oe = /* @__PURE__ */ new Set(["tab-pane", "fade", "show", "active"]), is = ({ children: e, eventKey: o, className: t, ...s }) => {
  const { activeKey: n } = ls();
  if (n !== o)
    return null;
  const r = ((t == null ? void 0 : t.split(/\s+/).filter(Boolean)) ?? []).filter((i) => !Oe.has(i)), d = [
    "tab-pane",
    "fade",
    "show",
    "active",
    ...new Set([...r].filter((i) => !Oe.has(i)))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: d, role: "tabpanel", ...s, children: e });
}, cs = ({ children: e, className: o }) => {
  const t = [
    "tab-content",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "tab-content"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, ds = ({
  children: e,
  defaultActiveKey: o,
  activeKey: t,
  onSelect: s,
  className: n,
  ...l
}) => {
  const [r, d] = H(
    () => o ?? ""
  ), i = t !== void 0, f = i ? t : r, a = P(
    (u) => {
      i || d(u), s == null || s(u);
    },
    [i, s]
  ), m = ot(
    () => ({ activeKey: f, onSelect: a }),
    [f, a]
  );
  return /* @__PURE__ */ c(Ue.Provider, { value: m, children: /* @__PURE__ */ c("div", { className: n, ...l, children: e }) });
}, Qe = ds;
Qe.Pane = is;
Qe.Content = cs;
const fs = ({
  el: e,
  children: o,
  className: t,
  ...s
}) => {
  const n = e || "span", l = [
    "navbar-brand",
    ...new Set((t ?? "").split(/\s+/).filter(Boolean).filter((r) => r !== "navbar-brand"))
  ].join(" ");
  return E(n, { ...s, className: l }, o);
}, us = ({
  children: e,
  className: o,
  ...t
}) => {
  const { toggle: s } = fe(), { expanded: n } = fe(), l = [
    "navbar-toggler",
    n ? "collapsed" : "",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((r) => r !== "navbar-toggler"))
  ].join(" ").trim();
  return /* @__PURE__ */ c(
    "button",
    {
      className: l,
      onClick: (r) => {
        var d;
        (d = t.onClick) == null || d.call(t, r), s();
      },
      ...t,
      children: e ?? /* @__PURE__ */ c("span", { className: "navbar-toggler-icon" })
    }
  );
}, ms = ({
  children: e,
  className: o,
  ...t
}) => {
  const { expanded: s } = fe(), n = [
    "navbar-collapse",
    s ? "collapse show" : "collapse",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((l) => !["navbar-collapse", "collapse", "show"].includes(l)))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: n, ...t, children: e });
}, we = (({ children: e, className: o, ...t }) => {
  const s = [
    "navbar",
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((n) => n !== "navbar")
    )
  ].join(" ");
  return /* @__PURE__ */ c(as, { children: /* @__PURE__ */ c("nav", { className: s, ...t, children: e }) });
});
we.Brand = fs;
we.Toggle = us;
we.Collapse = ms;
const ps = ({ children: e, className: o }) => {
  const t = [
    "offcanvas-body",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "offcanvas-body"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, gs = ({ children: e, className: o }) => {
  const t = [
    "offcanvas-header",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((s) => s !== "offcanvas-header"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: t, children: e });
}, Y = {
  Top: "offcanvas-top",
  Bottom: "offcanvas-bottom",
  Start: "offcanvas-start",
  End: "offcanvas-end"
}, Xn = {
  Sm: "offcanvas-sm",
  Md: "offcanvas-md",
  Lg: "offcanvas-lg",
  Xl: "offcanvas-xl",
  Xxl: "offcanvas-xxl"
}, Ze = (({
  children: e,
  className: o,
  placement: t = Y.Start,
  responsive: s,
  show: n = !1,
  bodyScroll: l = !1,
  onClose: r,
  backdropClose: d = !0,
  ...i
}) => {
  const m = "transform 0.3s ease-in-out", u = "opacity 0.15s linear", [g, w] = T.useState(!1), [b, X] = T.useState(!1), k = {
    [Y.Start]: "translateX(-100%)",
    [Y.End]: "translateX(100%)",
    [Y.Top]: "translateY(-100%)",
    [Y.Bottom]: "translateY(100%)"
  }, p = T.useMemo(() => [
    s || "offcanvas",
    t,
    ...new Set(
      (o ?? "").split(/\s+/).filter(Boolean).filter((v) => !v.startsWith("offcanvas"))
    )
  ].filter(Boolean).join(" "), [s, t, o]);
  T.useEffect(() => {
    if (n) {
      w(!0);
      const v = setTimeout(() => X(!0), 10);
      return () => clearTimeout(v);
    } else {
      X(!1);
      const v = setTimeout(() => w(!1), 300);
      return () => clearTimeout(v);
    }
  }, [n]), T.useEffect(() => {
    if (n && !l) {
      const v = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = "hidden", document.body.style.paddingRight = `${v}px`;
    } else
      document.body.style.overflow = "", document.body.style.paddingRight = "";
    return () => {
      document.body.style.overflow = "", document.body.style.paddingRight = "";
    };
  }, [n, l]), T.useEffect(() => {
    const v = (h) => {
      h.key === "Escape" && n && r && r();
    };
    if (n)
      return document.addEventListener("keydown", v), () => document.removeEventListener("keydown", v);
  }, [n, r]);
  const y = T.useCallback((v) => {
    d && r && v.target === v.currentTarget && r();
  }, [d, r]), O = T.useMemo(() => {
    const v = {
      visibility: g ? "visible" : "hidden",
      transition: m
    };
    return !b && g ? {
      ...v,
      transform: k[t] || "translateX(-100%)"
    } : { ...v, transform: "translate(0, 0)" };
  }, [g, b, t]), j = T.useMemo(() => ({
    transition: u,
    opacity: b ? 0.5 : 0
  }), [b]);
  return /* @__PURE__ */ N(q, { children: [
    g && /* @__PURE__ */ c(
      "div",
      {
        className: `${p}${b ? " show" : ""}`,
        style: O,
        "data-bs-scroll": l ? "true" : "false",
        "aria-modal": "true",
        role: "dialog",
        tabIndex: -1,
        ...i,
        children: e
      }
    ),
    g && !l && /* @__PURE__ */ c(
      "div",
      {
        className: `offcanvas-backdrop fade${b ? " show" : ""}`,
        onClick: y,
        style: j
      }
    )
  ] });
});
Ze.Header = gs;
Ze.Body = ps;
const xs = /* @__PURE__ */ new Set(["active"]), ws = /* @__PURE__ */ new Set(["disabled"]), Ss = ({ children: e, isActive: o, isDisabled: t, to: s, className: n }) => {
  const l = [
    ...o ? ["active"] : [],
    ...t ? ["disabled"] : []
  ], r = [
    { prop: o, set: xs },
    { prop: t, set: ws }
  ], i = ((n == null ? void 0 : n.split(/\s+/).filter(Boolean)) ?? []).filter(
    (a) => a !== "page-item" && !r.some(({ prop: m, set: u }) => m && u.has(a))
  ), f = [
    "page-item",
    ...new Set([...l, ...i].filter((a) => a !== "page-item"))
  ].join(" ");
  return /* @__PURE__ */ c("li", { className: f, children: /* @__PURE__ */ c("a", { className: "page-link", href: s, children: e }) });
}, bs = {
  Sm: "pagination-sm",
  Lg: "pagination-lg"
}, hs = {
  Start: "justify-content-start",
  End: "justify-content-end",
  Center: "justify-content-center"
}, Cs = new Set(Object.values(bs)), vs = new Set(
  Object.values(hs)
), ys = (({ className: e, children: o, size: t, alignment: s, ...n }) => {
  const l = [
    ...t ? [t] : [],
    ...s ? [s] : []
  ], r = [
    { prop: t, set: Cs },
    { prop: s, set: vs }
  ], i = ((e == null ? void 0 : e.split(/\s+/).filter(Boolean)) ?? []).filter(
    (a) => a !== "pagination" && !r.some(({ prop: m, set: u }) => m && u.has(a))
  ), f = [
    "pagination",
    ...new Set([...l, ...i].filter((a) => a !== "pagination"))
  ].join(" ");
  return /* @__PURE__ */ c("nav", { "aria-label": "Page navigation", children: /* @__PURE__ */ c("ul", { className: f, ...n, children: o }) });
});
ys.Item = Ss;
const U = (e) => e ? Array.isArray(e) ? e : [e] : [], Os = ({
  children: e,
  alignSelf: o,
  order: t,
  grow: s,
  shrink: n,
  fill: l,
  className: r,
  ...d
}) => {
  const i = [
    ...U(o),
    ...U(t),
    ...U(s),
    ...U(n),
    ...U(l)
  ], f = [
    { prop: o, set: new Set(Object.values(Fe)) },
    { prop: t, set: new Set(Object.values(He)) },
    { prop: s, set: new Set(Object.values(uo)) },
    { prop: n, set: new Set(Object.values(mo)) },
    { prop: l, set: new Set(Object.values(po)) }
  ], m = ((r == null ? void 0 : r.split(" ").filter(Boolean)) ?? []).filter(
    (g) => !f.some(({ prop: w, set: b }) => w && b.has(g))
  ), u = [...i, ...m].join(" ");
  return /* @__PURE__ */ c("div", { className: u, ...d, children: e });
}, $ = (e) => e ? Array.isArray(e) ? e : [e] : [], Ls = (({
  children: e,
  behavior: o = Ce.Flex,
  direction: t,
  alignItems: s,
  justifyContent: n,
  alignContent: l,
  wrap: r,
  gap: d,
  className: i,
  ...f
}) => {
  const a = [
    ...$(o),
    ...$(t),
    ...$(s),
    ...$(n),
    ...$(l),
    ...$(r),
    ...$(d)
  ], m = [
    { prop: o, set: new Set(Object.values(Ce)) },
    { prop: t, set: new Set(Object.values(ao)) },
    { prop: s, set: new Set(Object.values(Ae)) },
    { prop: n, set: new Set(Object.values(We)) },
    { prop: l, set: new Set(Object.values(co)) },
    { prop: r, set: new Set(Object.values(io)) },
    { prop: d, set: new Set(Object.values(fo)) }
  ], g = ((i == null ? void 0 : i.split(" ").filter(Boolean)) ?? []).filter(
    (b) => !m.some(({ prop: X, set: k }) => X && k.has(b))
  ), w = [...a, ...g].join(" ");
  return /* @__PURE__ */ c("div", { className: w, ...f, children: e });
});
Ls.Item = Os;
const Bs = {
  Primary: "bg-primary",
  Secondary: "bg-secondary",
  Success: "bg-success",
  Danger: "bg-danger",
  Warning: "bg-warning",
  Info: "bg-info",
  Light: "bg-light",
  Dark: "bg-dark"
}, Xs = {
  TopStart: "top-0 start-0",
  TopCenter: "top-0 start-50 translate-middle-x",
  TopEnd: "top-0 end-0",
  MiddleStart: "top-50 start-0 translate-middle-y",
  MiddleCenter: "top-50 start-50 translate-middle",
  MiddleEnd: "top-50 end-0 translate-middle-y",
  BottomStart: "bottom-0 start-0",
  BottomCenter: "bottom-0 start-50 translate-middle-x",
  BottomEnd: "bottom-0 end-0"
}, Es = ({ children: e, className: o, ...t }) => {
  const s = [
    "toast-body",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((n) => n !== "toast-body"))
  ].join(" ");
  return /* @__PURE__ */ c("div", { className: s, ...t, children: e });
}, ks = ({
  children: e,
  className: o = "",
  placement: t = Xs.TopEnd,
  position: s = "fixed",
  ...n
}) => {
  const l = [
    "toast-container",
    s === "fixed" ? "position-fixed" : "",
    t,
    "p-3",
    o
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ c("div", { className: l, ...n, children: e });
}, et = ({ children: e, className: o, closeButton: t = !0, onClose: s, ...n }) => {
  const l = [
    "toast-header",
    ...new Set((o ?? "").split(/\s+/).filter(Boolean).filter((r) => r !== "toast-header"))
  ].join(" ");
  return /* @__PURE__ */ N("div", { className: l, ...n, children: [
    e,
    t && /* @__PURE__ */ c(
      "button",
      {
        type: "button",
        className: "btn-close",
        "aria-label": "Close",
        onClick: s
      }
    )
  ] });
}, Ts = (e) => e ? Array.isArray(e) ? e : [e] : [], Rs = 10, Le = 300, Se = (({
  children: e,
  className: o,
  show: t = !1,
  onClose: s,
  autohide: n = !1,
  delay: l = 5e3,
  bg: r,
  animation: d = !0,
  ...i
}) => {
  const [f, a] = H(t), [m, u] = H(!1), g = I(null), w = P(() => {
    g.current && (clearTimeout(g.current), g.current = null), u(!1), g.current = setTimeout(() => {
      g.current = null, a(!1), s == null || s();
    }, Le);
  }, [s]);
  if (W(() => () => {
    g.current && clearTimeout(g.current);
  }, []), W(() => {
    if (t) {
      g.current && (clearTimeout(g.current), g.current = null), a(!0);
      const h = setTimeout(() => u(!0), Rs);
      return () => clearTimeout(h);
    }
    u(!1);
    const v = setTimeout(() => a(!1), Le);
    return () => clearTimeout(v);
  }, [t]), W(() => {
    if (!n || !m) return;
    const v = setTimeout(() => w(), l);
    return () => clearTimeout(v);
  }, [n, l, m, w]), !f) return null;
  const b = [...Ts(r)], X = [
    { prop: r, set: new Set(Object.values(Bs)) }
  ], p = ((o == null ? void 0 : o.split(/\s+/).filter(Boolean)) ?? []).filter(
    (v) => !X.some(({ prop: h, set: x }) => h && x.has(v))
  ), y = /* @__PURE__ */ new Set([...b, ...p]), O = [
    "toast",
    m ? "show" : "",
    d ? "fade" : "",
    ...new Set([...y].filter((v) => v !== "toast"))
  ].filter(Boolean).join(" "), j = T.Children.map(e, (v) => {
    if (T.isValidElement(v) && v.type === et) {
      const h = v.props;
      return T.cloneElement(v, {
        onClose: h.onClose ?? w
      });
    }
    return v;
  });
  return /* @__PURE__ */ c(
    "div",
    {
      className: O,
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true",
      ...i,
      children: j
    }
  );
});
Se.Header = et;
Se.Body = Es;
Se.Container = ks;
const Be = {
  Text: "text",
  Email: "email",
  Password: "password",
  Number: "number",
  Tel: "tel",
  Url: "url",
  Search: "search",
  Date: "date",
  Time: "time",
  DatetimeLocal: "datetime-local",
  Month: "month",
  Week: "week",
  Color: "color",
  File: "file",
  Hidden: "hidden",
  Range: "range"
}, En = {
  Small: "form-control-sm",
  Large: "form-control-lg"
}, kn = {
  Small: "input-group-sm",
  Large: "input-group-lg"
}, Tn = {
  Small: "form-select-sm",
  Large: "form-select-lg"
}, Z = {
  Valid: "valid-feedback",
  Invalid: "invalid-feedback",
  ValidTooltip: "valid-tooltip",
  InvalidTooltip: "invalid-tooltip"
}, Ns = {
  Muted: "text-muted"
}, js = ({
  el: e,
  type: o = Be.Text,
  className: t,
  size: s,
  plaintext: n = !1,
  isValid: l = !1,
  isInvalid: r = !1,
  onChange: d,
  ...i
}) => {
  const f = e || "input", a = [], m = o === Be.Range;
  s && !m && a.push(s), l && a.push("is-valid"), r && a.push("is-invalid");
  const u = [
    m ? "form-range" : n ? "form-control-plaintext" : "form-control",
    ...a,
    t || ""
  ].filter(Boolean).join(" ").trim(), g = {
    ...i,
    className: u || void 0,
    onChange: d
  };
  return f === "input" && (g.type = o), E(f, g);
}, Ps = ({
  el: e,
  children: o,
  className: t,
  htmlFor: s,
  column: n = !1,
  visuallyHidden: l = !1,
  ...r
}) => {
  const d = e || "label", i = [
    n === !0 ? "col-form-label" : n === "sm" ? "col-form-label col-form-label-sm" : n === "lg" ? "col-form-label col-form-label-lg" : "form-label",
    l ? "visually-hidden" : "",
    t || ""
  ].filter(Boolean).join(" ").trim();
  return E(
    d,
    {
      ...r,
      className: i || void 0,
      htmlFor: s
    },
    o
  );
}, Ms = ({
  el: e,
  children: o,
  className: t,
  controlId: s,
  as: n = "div",
  ...l
}) => {
  const r = n || e || "div", d = [
    "mb-3",
    t || ""
  ].filter(Boolean).join(" ").trim();
  return E(
    r,
    {
      ...l,
      id: s,
      className: d || void 0
    },
    o
  );
}, Ds = ({
  el: e,
  children: o,
  className: t,
  size: s,
  htmlSize: n,
  isValid: l = !1,
  isInvalid: r = !1,
  onChange: d,
  ...i
}) => {
  const f = e || "select", a = [];
  s && a.push(s), l && a.push("is-valid"), r && a.push("is-invalid");
  const m = [
    "form-select",
    ...a,
    t || ""
  ].filter(Boolean).join(" ").trim(), u = {
    ...i,
    className: m || void 0,
    onChange: d
  };
  return n && (u.size = n), E(f, u, o);
}, Is = ({
  el: e,
  type: o = "checkbox",
  label: t,
  className: s,
  inline: n = !1,
  reverse: l = !1,
  isValid: r = !1,
  isInvalid: d = !1,
  id: i,
  onChange: f,
  children: a,
  ...m
}) => {
  const u = e || "input", g = [
    "form-check-input",
    r ? "is-valid" : "",
    d ? "is-invalid" : ""
  ].filter(Boolean).join(" ").trim(), w = [
    o === "switch" ? "form-check form-switch" : "form-check",
    n ? "form-check-inline" : "",
    l ? "form-check-reverse" : "",
    s || ""
  ].filter(Boolean).join(" ").trim(), b = E(u, {
    ...m,
    id: i,
    type: o === "switch" ? "checkbox" : o,
    className: g || void 0,
    onChange: f
  });
  return t ? E(
    "div",
    { className: w || void 0 },
    b,
    E(
      "label",
      { className: "form-check-label", htmlFor: i },
      t
    ),
    ...a != null ? [a] : []
  ) : a != null ? E(
    "div",
    { className: w || void 0 },
    b,
    a
  ) : b;
}, Gs = ({
  el: e,
  children: o,
  className: t,
  type: s = "invalid",
  tooltip: n = !1,
  ...l
}) => {
  const r = e || "div", i = [
    n ? s === "valid" ? Z.ValidTooltip : Z.InvalidTooltip : s === "valid" ? Z.Valid : Z.Invalid,
    t || ""
  ].filter(Boolean).join(" ").trim();
  return E(
    r,
    {
      ...l,
      className: i || void 0
    },
    o
  );
}, As = ({
  el: e,
  children: o,
  className: t,
  muted: s = !0,
  ...n
}) => {
  const l = e || "small", r = [
    "form-text",
    s ? Ns.Muted : "",
    t || ""
  ].filter(Boolean).join(" ").trim();
  return E(
    l,
    {
      ...n,
      className: r || void 0
    },
    o
  );
}, Fs = ({
  value: e,
  children: o,
  ...t
}) => E("option", { value: e, ...t }, o), Ws = ({
  id: e,
  children: o,
  className: t,
  ...s
}) => E(
  "datalist",
  {
    id: e,
    className: t || void 0,
    ...s
  },
  o
), Hs = Object.assign(Ws, {
  Option: Fs
}), _s = ({
  className: e,
  children: o,
  size: t,
  nowrap: s = !1,
  ...n
}) => {
  const l = [
    "input-group",
    t,
    s && "flex-nowrap",
    ...new Set(
      (e ?? "").split(/\s+/).filter(Boolean).filter((r) => r !== "input-group")
    )
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ c("div", { className: l, ...n, children: o });
}, $s = ({
  el: e = "span",
  children: o,
  className: t,
  ...s
}) => {
  const n = [
    "input-group-text",
    ...new Set(
      (t ?? "").split(/\s+/).filter(Boolean).filter((l) => l !== "input-group-text")
    )
  ].filter(Boolean).join(" ");
  return E(e, { ...s, className: n }, o);
}, zs = ({
  el: e,
  children: o,
  className: t,
  validated: s = !1,
  inline: n = !1,
  onSubmit: l,
  ...r
}) => {
  const d = e || "form", i = [
    n ? "row row-cols-auto g-3 align-items-center" : "",
    s ? "was-validated" : "",
    t || ""
  ].filter(Boolean).join(" ").trim();
  return E(
    d,
    {
      ...r,
      className: i || void 0,
      onSubmit: (a) => {
        l && l(a);
      }
    },
    o
  );
}, Xe = Object.assign(zs, {
  Control: js,
  Label: Ps,
  Group: Ms,
  Select: Ds,
  Check: Is,
  Feedback: Gs,
  Text: As,
  Datalist: Hs,
  InputGroup: _s,
  InputGroupText: $s
}), ie = {
  blockType: {
    options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6", "Blockquote"]
  },
  fontSize: { options: [10, 12, 14, 16, 18, 24, 30, 36, 48] },
  textAlign: { options: ["left", "center", "right", "justify"] }
}, Ee = {
  Normal: "p",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  Blockquote: "blockquote"
}, Ys = {
  left: "justifyLeft",
  center: "justifyCenter",
  right: "justifyRight",
  justify: "justifyFull"
}, Us = {
  left: "L",
  center: "C",
  right: "R",
  justify: "J"
}, qs = (e, o) => {
  document.execCommand(e, !1, o ?? void 0);
};
function te(e) {
  if (!e || !(e instanceof HTMLSpanElement)) return !1;
  const o = e.getAttribute("style");
  if (!o || !o.toLowerCase().includes("font-size")) return !1;
  const t = o.split(";").map((s) => s.trim()).filter(Boolean);
  return t.length > 0 && t.every((s) => /^font-size\s*:/i.test(s));
}
function Vs(e) {
  return e.nodeType === Node.TEXT_NODE && !(e.textContent || "").replace(/\u00a0/g, " ").trim();
}
function Ks(e) {
  if (!te(e)) return null;
  let o = null;
  for (const t of e.childNodes) {
    if (Vs(t)) continue;
    if (t.nodeType !== Node.ELEMENT_NODE) return null;
    const s = t;
    if (s.tagName !== "SPAN" || !te(s) || o) return null;
    o = s;
  }
  return o;
}
function oe(e) {
  let o = !0;
  for (; o; ) {
    o = !1;
    for (const t of e.querySelectorAll("span[style*='font-size']")) {
      const s = Ks(t);
      if (!s) continue;
      const n = t.parentNode;
      if (n) {
        n.insertBefore(s, t), t.remove(), o = !0;
        break;
      }
    }
  }
}
function Js(e) {
  e.querySelectorAll("*").forEach((o) => {
    o.style.removeProperty("font-size");
    const t = o.getAttribute("style");
    t !== null && !t.trim() && o.removeAttribute("style");
  });
}
function ue(e) {
  var t, s;
  let o = !0;
  for (; o; ) {
    o = !1;
    for (const n of [...e.querySelectorAll("span")]) {
      if (!(n instanceof HTMLSpanElement) || !n.parentNode) continue;
      const l = [...n.attributes].some((i) => i.name !== "style" && i.name !== "class"), r = !((t = n.getAttribute("style")) != null && t.trim()), d = !((s = n.className) != null && s.trim());
      if (!l && r && d) {
        const i = n.parentNode;
        for (; n.firstChild; ) i.insertBefore(n.firstChild, n);
        i.removeChild(n), o = !0;
        break;
      }
    }
  }
}
function ke(e) {
  let o = !0;
  for (; o; )
    o = !1, e.querySelectorAll("span").forEach((t) => {
      !(t instanceof HTMLSpanElement) || !t.parentNode || t.childNodes.length === 0 && (t.remove(), o = !0);
    });
}
function Qs(e, o) {
  if (o.nodeType !== Node.ELEMENT_NODE) return !1;
  const t = document.createRange();
  try {
    return t.selectNodeContents(o), e.compareBoundaryPoints(Range.START_TO_START, t) >= 0 && e.compareBoundaryPoints(Range.END_TO_END, t) <= 0;
  } catch {
    return !1;
  }
}
function Zs(e, o) {
  let t = e.startContainer;
  for (t.nodeType === Node.TEXT_NODE && (t = t.parentNode); t && t !== o; ) {
    if (t instanceof HTMLSpanElement && te(t) && Qs(e, t))
      return t;
    t = t.parentNode;
  }
  return null;
}
function en(e, o) {
  let t = null, s = e;
  for (; s && s !== o; )
    s instanceof HTMLSpanElement && te(s) && (t = s), s = s.parentNode;
  return t;
}
function ce(e) {
  return e.replace(/\u00a0/g, " ").replace(/\r\n/g, `
`).trim();
}
function tn(e, o) {
  const t = Zs(e, o);
  if (!t) return e.cloneRange();
  const s = en(t, o);
  if (!s) return e.cloneRange();
  const n = ce(e.toString()), l = ce(t.textContent || ""), r = ce(s.textContent || "");
  if (!n || n !== r && n !== l)
    return e.cloneRange();
  const d = document.createRange();
  return d.selectNodeContents(s), d;
}
function on(e) {
  Js(e), ue(e), oe(e), ue(e);
}
function sn(e) {
  ke(e), ue(e), oe(e), ke(e);
}
const Rn = ({
  className: e = "",
  defaultValue: o = "",
  onChange: t,
  ariaLabelledBy: s
}) => {
  const n = I(null), l = I(!1), r = I(null), d = P(() => {
    const p = window.getSelection(), y = n.current;
    if (!(p != null && p.rangeCount) || !y) return;
    const O = p.getRangeAt(0);
    y.contains(O.commonAncestorContainer) && (r.current = O.cloneRange());
  }, []), i = P(() => {
    const p = n.current, y = r.current, O = window.getSelection();
    !p || !y || !O || (p.focus(), O.removeAllRanges(), O.addRange(y));
  }, []), f = P(() => {
    var p;
    t == null || t(((p = n.current) == null ? void 0 : p.innerHTML) ?? "");
  }, [t]);
  W(() => {
    const p = n.current;
    !p || l.current || (l.current = !0, o && (p.innerHTML = o), queueMicrotask(() => f()));
  }, [o, f]);
  const a = P(
    (p) => {
      var y;
      p.preventDefault(), (y = n.current) == null || y.focus(), i();
    },
    [i]
  ), m = P(
    (p, y) => {
      i(), qs(p, y);
      const O = n.current;
      O && oe(O), d(), f();
    },
    [d, f, i]
  ), u = P(
    (p) => {
      i();
      const y = n.current, O = window.getSelection();
      if (!(O != null && O.rangeCount) || !y) return;
      let j = O.getRangeAt(0);
      if (j.collapsed || !y.contains(j.commonAncestorContainer)) {
        f();
        return;
      }
      if (oe(y), O.rangeCount > 0 && y.contains(O.getRangeAt(0).commonAncestorContainer) && (r.current = O.getRangeAt(0).cloneRange()), !O.rangeCount) {
        f();
        return;
      }
      if (j = O.getRangeAt(0), j.collapsed) {
        f();
        return;
      }
      const v = tn(j, y), h = v.extractContents(), x = document.createElement("div");
      for (; h.firstChild; ) x.appendChild(h.firstChild);
      on(x);
      const S = document.createElement("span");
      for (S.style.fontSize = `${p}px`; x.firstChild; ) S.appendChild(x.firstChild);
      if (!S.hasChildNodes()) {
        d(), f();
        return;
      }
      v.insertNode(S), sn(y), O.removeAllRanges();
      const C = document.createRange();
      C.selectNodeContents(S), C.collapse(!1), O.addRange(C), r.current = C.cloneRange(), d(), f();
    },
    [d, f, i]
  ), g = P(
    (p) => {
      const y = p.target.value;
      !y || !(y in Ee) || (m("formatBlock", Ee[y]), p.target.selectedIndex = 0);
    },
    [m]
  ), w = P(
    (p) => {
      const y = p.target.value;
      if (!y) return;
      const O = Number(y);
      Number.isFinite(O) && u(O), p.target.selectedIndex = 0;
    },
    [u]
  ), b = (p, y, O) => /* @__PURE__ */ c(
    de,
    {
      type: ut.Button,
      size: Pe.Sm,
      color: me.OutlineSecondary,
      "aria-label": p,
      title: p,
      onMouseDown: a,
      onClick: y,
      className: "border-secondary-subtle",
      children: O
    }
  ), X = "form-select form-select-sm", k = { width: "auto", minWidth: "6.5rem" };
  return /* @__PURE__ */ N("div", { className: `html-editor form-control p-0 overflow-hidden ${e}`.trim(), children: [
    /* @__PURE__ */ N(
      "div",
      {
        className: "html-editor__toolbar border-bottom bg-light p-2 d-flex flex-wrap gap-2 align-items-center",
        role: "toolbar",
        "aria-label": "Formatting",
        children: [
          /* @__PURE__ */ N(re, { size: ee.Sm, children: [
            b("Bold", () => m("bold"), /* @__PURE__ */ c("strong", { children: "B" })),
            b("Italic", () => m("italic"), /* @__PURE__ */ c("em", { children: "I" })),
            b("Underline", () => m("underline"), /* @__PURE__ */ c("span", { className: "text-decoration-underline", children: "U" }))
          ] }),
          /* @__PURE__ */ N(
            Xe.Select,
            {
              className: `${X} border-secondary-subtle`,
              style: k,
              "aria-label": "Block type",
              defaultValue: "",
              onChange: g,
              children: [
                /* @__PURE__ */ c("option", { value: "", disabled: !0, children: "Block" }),
                ie.blockType.options.map((p) => /* @__PURE__ */ c("option", { value: p, children: p }, p))
              ]
            }
          ),
          /* @__PURE__ */ N(
            Xe.Select,
            {
              className: `${X} border-secondary-subtle`,
              style: k,
              "aria-label": "Font size",
              defaultValue: "",
              onChange: w,
              children: [
                /* @__PURE__ */ c("option", { value: "", disabled: !0, children: "Size" }),
                ie.fontSize.options.map((p) => /* @__PURE__ */ N("option", { value: String(p), children: [
                  p,
                  "px"
                ] }, p))
              ]
            }
          ),
          /* @__PURE__ */ N(re, { size: ee.Sm, children: [
            b("Bullet list", () => m("insertUnorderedList"), "• List"),
            b("Numbered list", () => m("insertOrderedList"), "1. List")
          ] }),
          /* @__PURE__ */ c(re, { size: ee.Sm, children: ie.textAlign.options.map(
            (p) => b(`Align ${p}`, () => m(Ys[p]), Us[p])
          ) })
        ]
      }
    ),
    /* @__PURE__ */ c(
      "div",
      {
        ref: n,
        className: "html-editor__content form-control border-0 rounded-0 shadow-none",
        contentEditable: !0,
        suppressContentEditableWarning: !0,
        role: "textbox",
        "aria-multiline": "true",
        "aria-label": s ? void 0 : "Rich text editor",
        "aria-labelledby": s,
        onInput: f,
        onBlur: () => {
          d(), f();
        },
        onMouseUp: d,
        onKeyUp: d
      }
    )
  ] });
}, Nn = {
  Sidebar: "layout-sidebar",
  FullSidebar: "layout-full-sidebar",
  OverlaySidebar: "layout-overlay-sidebar"
};
export {
  Xo as Accordion,
  Lo as AccordionItem,
  cn as Alert,
  st as AlertColor,
  co as AlignContent,
  Ae as AlignItems,
  Fe as AlignSelf,
  dn as Badge,
  lt as BadgeColor,
  it as BadgePlacement,
  at as BadgePosition,
  rt as BadgeRounded,
  ko as Breadcrumb,
  Eo as BreadcrumbItem,
  de as Button,
  me as ButtonColor,
  re as ButtonGroup,
  ee as ButtonGroupSize,
  Pe as ButtonSize,
  ut as ButtonType,
  z as Card,
  Ro as CardBody,
  To as CardColor,
  Mo as CardFooter,
  Po as CardHeader,
  jo as CardImage,
  ve as CardImagePlacement,
  Io as CardText,
  Do as CardTitle,
  wo as Col,
  Bn as Column,
  On as Container,
  ro as ContainerSize,
  vn as DataTable,
  _t as DataTableColor,
  Ht as DataTableSize,
  xe as Dropdown,
  F as DropdownDirection,
  Wo as DropdownItem,
  _o as DropdownMenu,
  $o as DropdownToggle,
  Z as FeedbackType,
  Dt as Figcaption,
  It as Figure,
  po as Fill,
  Xe as Form,
  Is as FormCheck,
  js as FormControl,
  En as FormControlSize,
  Be as FormControlType,
  Hs as FormDatalist,
  Gs as FormFeedback,
  Ms as FormGroup,
  Ps as FormLabel,
  Ds as FormSelect,
  Tn as FormSelectSize,
  As as FormText,
  Ns as FormTextVariant,
  fo as Gap,
  uo as Grow,
  xo as Gutter,
  wn as Heading,
  At as HeadingColor,
  Gt as HeadingSize,
  Rn as HtmlEditor,
  gn as Icon,
  xn as Image,
  _s as InputGroup,
  kn as InputGroupSize,
  $s as InputGroupText,
  We as JustifyContent,
  De as LabelOverflow,
  se as Layout,
  _e as LayoutContent,
  Co as LayoutFooter,
  bo as LayoutHeader,
  ho as LayoutSidebar,
  Nn as LayoutType,
  hn as List,
  Jo as ListGroup,
  Ko as ListGroupItem,
  Yo as ListGroupItemColor,
  Cn as ListItem,
  le as Modal,
  ts as ModalBody,
  es as ModalDialog,
  ss as ModalFooter,
  Zo as ModalFullscreen,
  os as ModalHeader,
  Qo as ModalSize,
  Je as Nav,
  ns as NavItem,
  rs as NavLink,
  we as Navbar,
  fs as NavbarBrand,
  ms as NavbarCollapse,
  us as NavbarToggler,
  Ze as Offcanvas,
  ps as OffcanvasBody,
  gs as OffcanvasHeader,
  Y as OffcanvasPlacement,
  Xn as OffcanvasResponsive,
  So as Offset,
  He as Order,
  ys as Pagination,
  hs as PaginationAlignment,
  Ss as PaginationItem,
  bs as PaginationSize,
  pn as Popover,
  A as PopoverPlacement,
  un as Progress,
  yt as ProgressColor,
  Ot as ProgressWidth,
  Ln as Row,
  go as RowCols,
  mo as Shrink,
  fn as Spinner,
  bt as SpinnerColor,
  St as SpinnerSize,
  Me as SpinnerType,
  Ls as Stack,
  Ce as StackBehavior,
  ao as StackDirection,
  Os as StackItem,
  io as StackWrap,
  cs as TabContent,
  is as TabPane,
  yn as Table,
  ge as TableColor,
  pe as TableSize,
  Qe as Tabs,
  Sn as Text,
  Se as Toast,
  Bs as ToastBg,
  Es as ToastBody,
  ks as ToastContainer,
  et as ToastHeader,
  Xs as ToastPlacement,
  mn as Tooltip,
  G as TooltipPlacement,
  bn as Wrapper
};
//# sourceMappingURL=index.mjs.map
